<template>
  <!-- Add isApp prop usage to the main container -->
  <div class="widget-min-h-screen" v-if="isPageLockedAndRequiresPassword">
    <div class="widget-flex widget-items-center widget-justify-center widget-min-h-screen">
      <div class="widget-w-full widget-max-w-md">
        <!-- Password Container -->
        <div class="widget-bg-white-80 widget-backdrop-blur-xl widget-rounded-2xl widget-p-8 widget-shadow-lg" style="padding: 32px !important;">
          <div class="widget-space-y-6">
            <!-- Lock Icon -->
            <div class="widget-flex widget-justify-center">
              <div class="widget-bg-gray-100 widget-rounded-full widget-p-4" style="padding: 16px !important;">
                <svg xmlns="http://www.w3.org/2000/svg" class="widget-w-8 widget-text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
            </div>

            <!-- Title -->
            <p class="heading-2 widget-text-2xl widget-font-medium widget-text-center widget-text-gray-900">Понадобится пароль</p>

            <!-- Password Input -->
            <div class="widget-space-y-2">
              <input 
                type="password"
                placeholder="••••••••"
                class="widget-w-full widget-py-3 widget-rounded-xl widget-input-border widget-input-text"
                v-model="enteredPassword"
                style="padding-top: 12px !important; padding-bottom: 12px !important;"
              />
              
              <!-- Password Hint -->
              <p class="widget-text-sm widget-text-gray-500 widget-text-center">
                Эта страница в разработке, нужен пароль, чтобы ее увидеть
              </p>
            </div>

            <!-- Submit Button -->
            <button 
              class="widget-btn-primary widget-bg-blue-500 widget-rounded-xl widget-py-3"
              @click="checkPassword()"
              style="padding-top: 12px !important; padding-bottom: 12px !important;"
            >
              Продолжить
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Add School Name Prompt -->
  <div class="widget-min-h-screen" v-else-if="isTestingOnSchools && !hasEnteredSchoolName">
    <div class="widget-flex widget-items-center widget-justify-center widget-min-h-screen">
      <div class="widget-w-full widget-max-w-md">
        <!-- School Container -->
        <div class="widget-bg-white-80 widget-backdrop-blur-xl widget-rounded-2xl widget-p-8 widget-shadow-lg" style="padding: 32px !important;">
          <div class="widget-space-y-6">
            <!-- School Icon -->
            <div class="widget-flex widget-justify-center">
              <div class="widget-bg-gray-100 widget-rounded-full widget-p-4" style="padding: 16px !important;">
                <svg xmlns="http://www.w3.org/2000/svg" class="widget-w-8 widget-text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
            </div>

            <!-- Title -->
            <p class="heading-2 widget-text-2xl widget-font-medium widget-text-center widget-text-gray-900">Ваша школа</p>

            <!-- School Input -->
            <div class="widget-space-y-2">
              <input 
                type="text"
                placeholder="Введите название школы"
                class="widget-w-full widget-py-3 widget-rounded-xl widget-input-border widget-input-text"
                v-model="enteredSchoolName"
                style="padding-top: 12px !important; padding-bottom: 12px !important;"
              />
              
              <!-- School Hint -->
              <p class="widget-text-sm widget-text-gray-500 widget-text-center">
                Укажите название школы, в которой вы учитесь, чтобы перейти к виджету.
              </p>
            </div>

            <!-- Submit Button -->
            <button 
              class="widget-btn-primary widget-bg-blue-500 widget-rounded-xl widget-py-3"
              @click="submitSchoolName()"
              style="padding-top: 12px !important; padding-bottom: 12px !important;"
            >
              Продолжить
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div 
    v-else
    :style="isApp ? 'height: 100vh; overflow-y: auto;' : 'background: #ffffff;'"
  >
    <div v-if="isLoadingData" class="widget-data-loading" aria-live="polite" aria-busy="true">
      <div class="widget-data-loading__inner">
        <div class="widget-data-loading__spinner" aria-hidden="true"></div>
        <p class="widget-data-loading__title">Загрузка калькулятора</p>
        <p class="widget-data-loading__subtitle">Подготавливаем программы и достижения…</p>
        <div class="widget-data-loading__skeleton" aria-hidden="true">
          <div class="widget-data-loading__line widget-data-loading__line--long"></div>
          <div class="widget-data-loading__line widget-data-loading__line--short"></div>
          <div class="widget-data-loading__block"></div>
        </div>
      </div>
    </div>

    <div v-else-if="isLoadError" class="widget-data-error">
      <p class="widget-data-error__title">Не удалось загрузить данные</p>
      <p class="widget-data-error__subtitle">Попробуйте обновить страницу позже.</p>
    </div>

    <div 
      v-else
      :fullscreen="true" 
      :style="isApp ? 'height: 100%; overflow-y: auto;' : 'background: #ffffff;'"
    >
      <!-- Main container with responsive grid -->
      <div 
        class="main-grid-container"
        style="margin-left: auto; margin-right: auto; display: grid; grid-template-columns: 1fr; gap: 24px;"
      >
        <!-- Left side with search and results -->
        <div class="main-content-column" style="grid-column: span 1;">
          <div style="padding: 8px 0; display: flex; flex-direction: column; gap: 12px;">
            <custom-segment
              v-model="currentSegment"
              :options="[
                { value: 'view_all', label: 'Все достижения' },
                { value: 'calculator', label: 'Калькулятор по программам' },
              ]"
              :font-size="14"
            />

            <!-- Program Selection Button -->
            <div v-if="currentSegment === 'calculator'" style="margin-top: 8px;">
              <button
                @click="openProgramModal"
                style="
                  width: 100%;
                  padding: 14px 20px;
                  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                  border: 1px solid #bfdbfe;
                  color: #1d4ed8;
                  border-radius: 12px;
                  font-size: 15px;
                  font-weight: 500;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  transition: all 0.2s ease;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
                "
                onmouseover="this.style.background='linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)'; this.style.boxShadow='0 2px 6px rgba(59, 130, 246, 0.15)';"
                onmouseout="this.style.background='linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.05)';"
              >
                <span>{{ selectedProgramName || "Выберите программу" }}</span>
                <svg
                  style="width: 20px; height: 20px;"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
            </div>
          </div>

          <!-- Program Selection Modal -->
          <ion-modal
            :is-open="showProgramModal"
            @didDismiss="closeProgramModal"
            class="program-modal"
            :breakpoints="[0, 1]"
            :initial-breakpoint="1"
          >
            <ion-header class="ion-no-border">
              <ion-toolbar style="--background: #ffffff; --border-width: 0;">
                <ion-title style="font-size: 18px; font-weight: 600; color: #111827;">Выберите программу</ion-title>
                <ion-buttons slot="end">
                  <ion-button @click="closeProgramModal" style="--color: #6b7280;">
                    <ion-icon :icon="close"></ion-icon>
                  </ion-button>
                </ion-buttons>
              </ion-toolbar>
            </ion-header>

            <ion-content style="--padding-start: 16px; --padding-end: 16px; --padding-top: 16px; --padding-bottom: 16px; --background: #fafafa;">
              <!-- Search and Campus Filter -->
              <div style="display: flex; flex-direction: column; gap: 8px;">
                <div
                  style="
                    position: relative;
                    background: rgba(255, 255, 255, 0.95);
                    backdrop-filter: blur(20px);
                    border-radius: 14px;
                    padding: 8px;
                    border: 1px solid #e5e7eb;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
                  "
                >
                  <ion-searchbar
                    v-model="programSearchQuery"
                    :debounce="300"
                    placeholder="Поиск программ..."
                    class="search-ios"
                    search-icon-position="start"
                    :clear-icon="programSearchQuery ? 'close-circle' : ''"
                    style="--background: transparent; --box-shadow: none; margin: 0; padding: 0;"
                  >
                  </ion-searchbar>
                </div>
              </div>

              <!-- Programs List Grouped by Campus -->
              <div style="margin-top: 20px; display: flex; flex-direction: column; gap: 28px;">
                <template
                  v-for="(programs, campus) in groupedPrograms"
                  :key="campus"
                >
                  <!-- Campus Header -->
                  <div v-if="programs.length > 0" style="display: flex; flex-direction: column; gap: 14px;">
                    <div style="display: flex; align-items: center; gap: 12px;">
                      <p
                        class="heading-3"
                        style="display: flex; align-items: center; font-size: 17px; font-weight: 600; color: #111827; margin: 0;"
                      >
                        <div
                          style="flex-shrink: 0; width: 4px; height: 18px; background: #2563eb; border-radius: 4px;"
                        ></div>
                        <span style="margin-left: 10px;">{{
                          campus === "all" ? "Все кампусы" : campus
                        }}</span>
                      </p>
                    </div>

                    <!-- Programs for this campus -->
                    <div style="display: flex; flex-direction: column; gap: 10px;">
                      <button
                        v-for="program in programs"
                        :key="program"
                        @click="selectProgram(program)"
                        style="
                          width: 100%;
                          padding: 14px 16px;
                          text-align: left;
                          background: #ffffff;
                          border: 1px solid #e5e7eb;
                          border-radius: 12px;
                          font-size: 15px;
                          color: #374151;
                          cursor: pointer;
                          transition: all 0.15s ease;
                          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
                        "
                        onmouseover="this.style.background='#f9fafb'; this.style.borderColor='#d1d5db'; this.style.boxShadow='0 2px 4px rgba(0, 0, 0, 0.05)';"
                        onmouseout="this.style.background='#ffffff'; this.style.borderColor='#e5e7eb'; this.style.boxShadow='0 1px 2px rgba(0, 0, 0, 0.03)';"
                      >
                        {{ program }}
                      </button>
                    </div>
                  </div>
                </template>
              </div>
            </ion-content>
          </ion-modal>
          <!-- Search Section - Card-style version -->
          <div v-if="currentSegment == 'view_all'" style="padding: 8px 0;">
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <!-- Search and Filter Group -->
              <div
                style="
                  position: relative;
                  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
                  border: 1px solid #e2e8f0;
                  border-radius: 16px;
                  padding: 10px 12px;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.8);
                "
              >
                <!-- Native search input (height controllable; ion-searchbar uses Shadow DOM) -->
                <div
                  class="achievements-search-native"
                  style="
                    position: relative;
                    background: #ffffff;
                    border-radius: 10px;
                    border: 1px solid #d1d5db;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
                    height: 56px;
                    display: flex;
                    align-items: center;
                    padding: 0 12px 0 44px;
                    transition: border-color 0.15s ease, box-shadow 0.15s ease;
                  "
                >
                  <svg
                    style="position: absolute; left: 14px; width: 20px; height: 20px; color: #808080; pointer-events: none;"
                    fill="none" stroke="currentColor" viewBox="0 0 24 24"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                  <input
                    type="search"
                    v-model="searchQuery"
                    @input="onAchievementsSearchInput"
                    placeholder="Поиск достижений/олимпиад..."
                    style="
                      flex: 1;
                      border: none;
                      background: transparent;
                      font-size: 17px;
                      color: #000;
                      outline: none;
                      height: 100%;
                      min-width: 0;
                    "
                  />
                  <button
                    v-if="searchQuery"
                    type="button"
                    @click="searchQuery = ''"
                    style="
                      flex-shrink: 0;
                      width: 28px;
                      height: 28px;
                      margin-left: 4px;
                      padding: 0;
                      border: none;
                      background: transparent;
                      color: #808080;
                      cursor: pointer;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      border-radius: 50%;
                    "
                    aria-label="Очистить"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10" />
                      <path d="M15 9l-6 6M9 9l6 6" stroke-linecap="round" />
                    </svg>
                  </button>
                </div>

                <!-- Grade and Profile Selection -->
                <div v-if="isOlympiadSelected" style="margin-top: 14px; display: flex; flex-direction: column; gap: 10px;">
                  <!-- Grade Selection -->
                  <select 
                    v-model="selectedGrade" 
                    class="search-block-select"
                    style="
                      width: 100%;
                      padding: 12px 40px 12px 14px;
                      background: #ffffff url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27none%27 viewBox=%270 0 24 24%27 stroke=%27%236b7280%27 stroke-width=%272%27%3e%3cpath stroke-linecap=%27round%27 stroke-linejoin=%27round%27 d=%27M19 9l-7 7-7-7%27/%3e%3c/svg%3e') no-repeat right 14px center;
                      border: 1px solid #d1d5db;
                      border-radius: 10px;
                      font-size: 15px;
                      color: #374151;
                      cursor: pointer;
                      appearance: none;
                      -webkit-appearance: none;
                      transition: border-color 0.15s ease, box-shadow 0.15s ease;
                    "
                  >
                    <option value="">Выберите класс</option>
                    <option value="10">10 класс</option>
                    <option value="11">11 класс</option>
                  </select>

                  <!-- Profile Selection -->
                  <select 
                    v-model="selectedProfile" 
                    class="search-block-select"
                    style="
                      width: 100%;
                      padding: 12px 40px 12px 14px;
                      background: #ffffff url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27none%27 viewBox=%270 0 24 24%27 stroke=%27%236b7280%27 stroke-width=%272%27%3e%3cpath stroke-linecap=%27round%27 stroke-linejoin=%27round%27 d=%27M19 9l-7 7-7-7%27/%3e%3c/svg%3e') no-repeat right 14px center;
                      border: 1px solid #d1d5db;
                      border-radius: 10px;
                      font-size: 15px;
                      color: #374151;
                      cursor: pointer;
                      appearance: none;
                      -webkit-appearance: none;
                      transition: border-color 0.15s ease, box-shadow 0.15s ease;
                    "
                  >
                    <option value="">Выберите профиль</option>
                    <option
                      v-for="profile in availableProfiles"
                      :key="profile"
                      :value="profile"
                    >
                      {{ profile }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Updated Suggestions Dropdown -->
              <div
                v-if="searchQuery && suggestions.length > 0 && showSuggestions"
                style="position: relative;"
              >
                <div
                  style="
                    position: absolute;
                    z-index: 50;
                    width: 100%;
                    background: rgba(255, 255, 255, 0.98);
                    backdrop-filter: blur(20px);
                    border-radius: 14px;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05);
                    margin-top: 6px;
                    overflow: hidden;
                  "
                >
                  <div style="padding: 6px 0;">
                    <div
                      v-for="suggestion in suggestions"
                      :key="suggestion"
                      @click="selectSuggestion(suggestion)"
                      class="suggestion-item"
                      style="
                        padding: 14px 16px;
                        cursor: pointer;
                        transition: background 0.12s ease;
                      "
                      onmouseover="this.style.background='#f5f7fa';"
                      onmouseout="this.style.background='transparent';"
                    >
                      <div style="display: flex; align-items: center; gap: 12px;">
                        <svg
                          style="width: 18px; height: 18px; color: #9ca3af; flex-shrink: 0;"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        </svg>
                        <span style="font-size: 15px; color: #1f2937; word-break: break-word;">{{
                          suggestion
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Info Banner with Mascot -->
          <div style="margin-top: 23px;">
            <div
              style="
                position: relative;
                background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                border: 1px solid #bfdbfe;
                border-radius: 16px;
                overflow: visible;
              "
            >
              <!-- Mascot peeking over the top -->
              <div
                style="
                  position: absolute;
                  left: 7px;
                  right: 15px;
                  top: -25px;
                  width: 67px;
                  height: 67px;
                  z-index: 1;
                "
              >
                <img
                  src="@/assets/voronahse_cute.png"
                  alt="Воронка"
                  style="width: 100%; height: 100%; object-fit: contain; display: block;"
                />
              </div>

              <!-- Collapsed bar -->
              <div
                style="display: flex; align-items: center; gap: 10px; padding: 14px 14px 14px 78px; cursor: pointer; min-height: 28px;"
                @click="infoBannerExpanded = !infoBannerExpanded"
              >
                <p style="flex: 1; font-size: 12px; color: #1e40af; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  Воронка старается для вас, но возможны неточности
                </p>
                <svg
                  style="width: 16px; height: 16px; color: #3b82f6; flex-shrink: 0; transition: transform 0.2s ease;"
                  :style="infoBannerExpanded ? 'transform: rotate(180deg)' : 'transform: rotate(0deg)'"
                  fill="none" stroke="currentColor" viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>

              <!-- Expanded content -->
              <div v-if="infoBannerExpanded" style="padding: 0 14px 14px 14px; border-top: 1px solid #bfdbfe;">
                <p style="font-size: 13px; line-height: 1.5; color: #1e40af; margin: 10px 0 0 0;">
                  Воронка старается для вас, но возможны неточности.<br/>Всегда
                  <a
                    target="_blank"
                    href="https://ba.hse.ru/dost"
                    style="font-size: 13px; font-weight: 500; color: #1e40af; text-decoration: underline;"
                  >
                    перепроверяйте информацию в официальных документах на сайте
                  </a>
                </p>
                <button
                  @click="showReviewModal = true"
                  style="
                    margin-top: 10px;
                    padding: 6px 12px;
                    font-size: 12px;
                    font-weight: 500;
                    color: #7c3aed;
                    background: rgba(139, 92, 246, 0.1);
                    border: 1px solid rgba(139, 92, 246, 0.2);
                    border-radius: 8px;
                    cursor: pointer;
                    transition: all 0.15s ease;
                  "
                  onmouseover="this.style.background='rgba(139, 92, 246, 0.15)'; this.style.borderColor='rgba(139, 92, 246, 0.3)';"
                  onmouseout="this.style.background='rgba(139, 92, 246, 0.1)'; this.style.borderColor='rgba(139, 92, 246, 0.2)';"
                >
                  Оставить отзыв о виджете
                </button>
              </div>
            </div>
          </div>

          <!-- Main Content -->
          <div v-if="currentSegment == 'view_all'" style="padding-bottom: 24px;">
            <!-- Results Grid -->
            <div v-if="groupedResults" style="margin-top: 24px; display: flex; flex-direction: column; gap: 32px;">
              <!-- Campus Group -->
              <div
                v-for="(items, campus) in groupedResults"
                :key="campus"
                style="display: flex; flex-direction: column; gap: 16px;"
              >
                <!-- Campus Header -->
                <div style="display: flex; align-items: center; gap: 12px; padding: 0 4px;">
                  <p class="heading-2" style="display: flex; align-items: center; font-size: 18px; font-weight: 700; color: #111827; margin: 0;">
                    <div
                      style="flex-shrink: 0; width: 4px; height: 22px; background: #2563eb; border-radius: 4px;"
                    ></div>
                    <span style="margin-left: 10px;">
                      <span v-if="campus == 'all'">Все кампусы</span>
                      <span v-else>{{ campus }}</span>
                    </span>
                  </p>
                </div>

                <!-- Programs Grid -->
                <div style="display: flex; flex-direction: column; gap: 14px; padding: 0 4px;">
                  <div
                    v-for="item in items"
                    :key="item.title"
                    class="result-card"
                    style="
                      position: relative;
                      background: #ffffff;
                      border-radius: 16px;
                      border: 1px solid #e5e7eb;
                      overflow: hidden;
                      transition: all 0.2s ease;
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
                    "
                    onmouseover="this.style.boxShadow='0 8px 24px rgba(0, 0, 0, 0.08)'; this.style.borderColor='#d1d5db'; this.style.transform='translateY(-2px)';"
                    onmouseout="this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.04)'; this.style.borderColor='#e5e7eb'; this.style.transform='translateY(0)';"
                  >
                    <div style="position: relative; padding: 20px; display: flex; flex-direction: column; gap: 12px;">
                      <!-- Program Header -->
                      <div style="display: flex; flex-direction: column; gap: 8px;">
                        <p
                          class="heading-3"
                          style="font-size: 16px; font-weight: 600; color: #111827; margin: 0; word-break: break-word; line-height: 1.4;"
                          :style="item.isHeader ? 'color: #2563eb;' : ''"
                        >
                          {{ item.title }}
                        </p>
                        <div
                          v-if="item.points"
                          style="display: flex; flex-wrap: wrap; gap: 8px; align-items: center;"
                        >
                          <span
                            style="
                              display: inline-flex;
                              align-items: center;
                              padding: 6px 14px;
                              background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                              border: 1px solid #bfdbfe;
                              border-radius: 20px;
                              font-size: 13px;
                              font-weight: 600;
                              color: #1d4ed8;
                            "
                          >
                            {{ item.points }} баллов
                          </span>
                        </div>
                      </div>

                      <!-- Program Details -->
                      <p style="font-size: 14px; color: #6b7280; margin: 0; line-height: 1.5;">
                        <span
                          v-if="
                            item.program_name == 'all' && item.campus == 'all'
                          "
                          >Это достижение учитывается на всех образовательных
                          программах университета</span
                        >
                        <span
                          v-if="
                            item.program_name == 'all' && item.campus != 'all'
                          "
                          >Это достижение учитывается на всех образовательных
                          программах кампуса {{ item.campus }}</span
                        >
                      </p>

                      <div
                        v-if="item.details"
                        style="display: flex; align-items: flex-start; gap: 10px; padding-top: 4px;"
                      >
                        <svg
                          style="width: 18px; height: 18px; color: #9ca3af; flex-shrink: 0; margin-top: 2px;"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <p style="font-size: 14px; color: #6b7280; margin: 0; line-height: 1.5;">
                          {{ item.details }}
                        </p>
                      </div>
                      <div v-if="item.profiles" style="margin-top: 8px;">
                        <div
                          v-for="profile in item.profiles"
                          :key="profile.profile"
                          style="font-size: 14px; color: #4b5563; padding: 2px 0;"
                        >
                          {{ profile.profile }} - Уровень {{ profile.level }}
                        </div>
                      </div>
                      <!-- Benefits badge -->
                      <div
                        v-if="item.benefits"
                        style="display: flex; flex-direction: column; gap: 8px; margin-top: 8px;"
                      >
                        <span
                          v-for="(benefit, index) in item.benefits.split('\n')"
                          :key="index"
                          style="
                            display: inline-flex;
                            align-items: center;
                            padding: 8px 14px;
                            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
                            border: 1px solid #bbf7d0;
                            border-radius: 10px;
                            font-size: 13px;
                            font-weight: 500;
                            color: #166534;
                          "
                        >
                          {{ benefit }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div v-else style="margin-top: 32px;">
              <div
                style="
                  background: #ffffff;
                  border-radius: 16px;
                  border: 1px solid #e5e7eb;
                  overflow: hidden;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
                "
              >
                <!-- Top Section -->
                <div style="padding: 20px 24px; display: flex; align-items: center; gap: 16px;">
                  <div
                    style="
                      width: 48px;
                      height: 48px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                      border-radius: 12px;
                      flex-shrink: 0;
                    "
                  >
                    <svg
                      style="width: 24px; height: 24px; color: #2563eb;"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                  <div style="flex: 1; min-width: 0;">
                    <p style="font-size: 14px; color: #6b7280; margin: 0; line-height: 1.6; padding: 4px 0;">
                      {{
                        isOlympiadSelected
                          ? "Чтобы увидеть программы, для которых учитывается данная олимпиада, выберите класс и профиль олимпиады в полях выше"
                          : searchQuery
                          ? "Попробуйте изменить поисковый запрос или выбрать другой кампус"
                          : "Введите ключевые слова в поисковую строку для поиска по индивидуальным достижениям. Например:"
                      }}
                    </p>
                  </div>
                </div>

                <!-- Tips Section (shown only when no search query and not olympiad selection) -->
                <div
                  v-if="!searchQuery && !isOlympiadSelected"
                  style="border-top: 1px solid #f3f4f6;"
                >
                  <div style="padding: 16px 24px;">
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                      <button
                        @click="prefillSearchQuery('Аттестат с отличием')"
                        style="
                          display: flex;
                          align-items: center;
                          gap: 10px;
                          padding: 10px 16px;
                          background: #f9fafb;
                          border: 1px solid #e5e7eb;
                          border-radius: 10px;
                          cursor: pointer;
                          transition: all 0.15s ease;
                        "
                        onmouseover="this.style.background='#f3f4f6'; this.style.borderColor='#d1d5db';"
                        onmouseout="this.style.background='#f9fafb'; this.style.borderColor='#e5e7eb';"
                      >
                        <span
                          style="width: 8px; height: 8px; background: #3b82f6; border-radius: 50%;"
                        ></span>
                        <span style="font-size: 14px; color: #374151;"
                          >Аттестат с отличием</span
                        >
                      </button>
                      
                      <button
                        @click="prefillSearchQuery('Золотой знак ГТО')"
                        style="
                          display: flex;
                          align-items: center;
                          gap: 10px;
                          padding: 10px 16px;
                          background: #f9fafb;
                          border: 1px solid #e5e7eb;
                          border-radius: 10px;
                          cursor: pointer;
                          transition: all 0.15s ease;
                        "
                        onmouseover="this.style.background='#f3f4f6'; this.style.borderColor='#d1d5db';"
                        onmouseout="this.style.background='#f9fafb'; this.style.borderColor='#e5e7eb';"
                      >
                        <span
                          style="width: 8px; height: 8px; background: #3b82f6; border-radius: 50%;"
                        ></span>
                        <span style="font-size: 14px; color: #374151;"
                          >Золотой знак ГТО</span
                        >
                      </button>
                      
                      <button
                        @click="prefillSearchQuery('Всероссийская олимпиада школьников «Высшая проба»')"
                        style="
                          display: flex;
                          align-items: center;
                          gap: 10px;
                          padding: 10px 16px;
                          background: #f9fafb;
                          border: 1px solid #e5e7eb;
                          border-radius: 10px;
                          cursor: pointer;
                          transition: all 0.15s ease;
                        "
                        onmouseover="this.style.background='#f3f4f6'; this.style.borderColor='#d1d5db';"
                        onmouseout="this.style.background='#f9fafb'; this.style.borderColor='#e5e7eb';"
                      >
                        <span
                          style="width: 8px; height: 8px; background: #3b82f6; border-radius: 50%;"
                        ></span>
                        <span style="font-size: 14px; color: #374151;">Высшая проба</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Calculator Content Section -->
          <div
            v-if="currentSegment === 'calculator' && selectedProgramName"
            style="margin-top: 24px;"
          >
            <!-- Calculator Search Bar -->
            <div
              style="
                position: relative;
                background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
                border: 1px solid #e2e8f0;
                border-radius: 14px;
                padding: 10px 12px;
                margin-top: 16px;
              "
            >
              <ion-searchbar
                v-model="calculatorSearchQuery"
                :debounce="300"
                placeholder="Поиск достижений..."
                class="search-ios"
                search-icon-position="start"
                :clear-icon="calculatorSearchQuery ? 'close-circle' : ''"
                style="--background: #ffffff; --border-radius: 10px; --box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05); margin: 0; padding: 0;"
              ></ion-searchbar>
            </div>

            <!-- Filter Segment (hidden when searching) -->
            <div v-if="!calculatorSearchQuery">
              <custom-segment
                v-model="filterCategory"
                @change="selectFilterCategory"
                :options="[
                  { value: 'popular', label: 'Популярное' },
                  { value: 'regional_vso', label: 'Регион ВСоШ' },
                  { value: 'hse_contests', label: 'Организованно ВШЭ' },
                  { value: 'olympiads', label: 'Олимпиады РСОШ' },
                  { value: 'all', label: 'Все' },
                ]"
                :font-size="13"
                :scrollable="true"
                style="margin-top: 14px;"
              />

              <!-- Description Area -->
              <transition name="fade">
                <div 
                  v-if="filterCategory && segmentDescriptions[filterCategory]" 
                  style="
                    margin-top: 14px;
                    padding: 14px 16px;
                    background: #f9fafb;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                  "
                >
                  <p style="font-size: 14px; color: #4b5563; line-height: 1.5; margin: 0;">
                    {{ segmentDescriptions[filterCategory] }}
                  </p>
                </div>
              </transition>
            </div>

            <!-- Calculator Results Grid -->
            <div v-if="calculatorResults" style="margin-top: 24px; display: flex; flex-direction: column; gap: 32px;">
              <!-- Achievement Types Group -->
              <div
                v-for="(items, type) in calculatorResults"
                :key="type"
                style="display: flex; flex-direction: column; gap: 16px;"
              >
                <!-- Type Header -->
                <div style="display: flex; align-items: center; gap: 12px; padding: 0 4px;">
                  <p class="heading-2" style="display: flex; align-items: center; font-size: 18px; font-weight: 700; color: #111827; margin: 0;">
                    <div
                      style="flex-shrink: 0; width: 4px; height: 22px; background: #2563eb; border-radius: 4px;"
                    ></div>
                    <span style="margin-left: 10px;">{{ displayCategory(type) }}</span>
                  </p>
                </div>

                <!-- Achievements Grid -->
                <div style="display: flex; flex-direction: column; gap: 14px; padding: 0 4px;">
                  <div
                    v-for="item in items"
                    :key="item.title"
                    class="calculator-card"
                    style="
                      position: relative;
                      background: #ffffff;
                      border-radius: 16px;
                      border: 1px solid #e5e7eb;
                      overflow: hidden;
                      transition: all 0.2s ease;
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
                    "
                    onmouseover="this.style.boxShadow='0 8px 24px rgba(0, 0, 0, 0.08)'; this.style.borderColor='#d1d5db'; this.style.transform='translateY(-2px)';"
                    onmouseout="this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.04)'; this.style.borderColor='#e5e7eb'; this.style.transform='translateY(0)';"
                  >
                    <div style="position: relative; padding: 20px; display: flex; flex-direction: column; gap: 12px;">
                      <div style="display: flex; flex-direction: column; gap: 8px;">
                        <p
                          class="heading-3"
                          style="font-size: 16px; font-weight: 600; color: #111827; margin: 0; word-break: break-word; line-height: 1.4;"
                        >
                          {{ item.title }}
                          <span v-if="item.olympiadProfile" style="font-size: 14px; font-weight: 500; color: #6b7280;">
                            профиль: {{ item.olympiadProfile }}
                          </span>
                        </p>
                        <div
                          v-if="item.points"
                          style="display: flex; flex-wrap: wrap; gap: 8px; align-items: center;"
                        >
                          <span
                            style="
                              display: inline-flex;
                              align-items: center;
                              padding: 6px 14px;
                              background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                              border: 1px solid #bfdbfe;
                              border-radius: 20px;
                              font-size: 13px;
                              font-weight: 600;
                              color: #1d4ed8;
                            "
                          >
                            {{ item.points }} баллов
                          </span>
                        </div>
                      </div>

                      <div
                        v-if="item.details"
                        style="display: flex; align-items: flex-start; gap: 10px; padding-top: 4px;"
                      >
                        <svg
                          style="width: 18px; height: 18px; color: #9ca3af; flex-shrink: 0; margin-top: 2px;"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <p style="font-size: 14px; color: #6b7280; margin: 0; line-height: 1.5;">
                          {{ item.details }}
                        </p>
                      </div>
                      
                      <!-- Add to Cart Button -->
                      <div style="display: flex; justify-content: flex-end; margin-top: 12px;">
                        <button
                          @click="addToCart(item)"
                          :disabled="isItemInCart(item)"
                          :style="isItemInCart(item) 
                            ? 'display: inline-flex; align-items: center; gap: 8px; padding: 10px 18px; font-size: 14px; font-weight: 500; background: #f3f4f6; color: #6b7280; border: 1px solid #d1d5db; border-radius: 10px; cursor: default;'
                            : 'display: inline-flex; align-items: center; gap: 8px; padding: 10px 18px; font-size: 14px; font-weight: 500; background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%); color: #1d4ed8; border: 1px solid #bfdbfe; border-radius: 10px; cursor: pointer; transition: all 0.15s ease;'"
                          onmouseover="if(!this.disabled) { this.style.background='linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)'; this.style.boxShadow='0 2px 8px rgba(59, 130, 246, 0.2)'; }"
                          onmouseout="if(!this.disabled) { this.style.background='linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)'; this.style.boxShadow='none'; }"
                        >
                          <svg
                            :style="isItemInCart(item) ? 'width: 18px; height: 18px; color: #22c55e;' : 'width: 18px; height: 18px; color: #2563eb;'"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              v-if="!isItemInCart(item)"
                              stroke-linecap="round" 
                              stroke-linejoin="round" 
                              stroke-width="2" 
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            />
                            <path 
                              v-else
                              stroke-linecap="round" 
                              stroke-linejoin="round" 
                              stroke-width="2.5" 
                              d="M5 13l4 4L19 7" 
                            />
                          </svg>
                          <span :style="isItemInCart(item) ? 'font-weight: 600;' : ''">
                            {{ isItemInCart(item) ? "Добавлено" : "Добавить" }}
                          </span>
                        </button>
                      </div>
                      
                      <!-- Benefits Section -->
                      <div
                        v-if="item.benefits"
                        style="display: flex; flex-direction: column; gap: 8px; margin-top: 8px;"
                      >
                        <span
                          v-for="(benefit, index) in item.benefits.split('\n')"
                          :key="index"
                          style="
                            display: inline-flex;
                            align-items: center;
                            padding: 8px 14px;
                            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
                            border: 1px solid #bbf7d0;
                            border-radius: 10px;
                            font-size: 13px;
                            font-weight: 500;
                            color: #166534;
                          "
                        >
                          {{ benefit }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty State for Calculator -->
            <div v-else-if="selectedProgramName" style="margin-top: 32px;">
              <div
                style="
                  background: #ffffff;
                  border-radius: 16px;
                  border: 1px solid #e5e7eb;
                  padding: 24px;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
                "
              >
                <div style="display: flex; align-items: center; gap: 16px;">
                  <div
                    style="
                      width: 48px;
                      height: 48px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
                      border-radius: 12px;
                      flex-shrink: 0;
                    "
                  >
                    <svg
                      style="width: 24px; height: 24px; color: #d97706;"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                  <p style="font-size: 14px; color: #6b7280; margin: 0; line-height: 1.5;">
                    Не найдено достижений для выбранной программы. Попробуйте
                    изменить поисковый запрос.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Disclaimer Text -->
          <div style="text-align: center; color: #9ca3af; font-size: 12px; margin-top: 32px; margin-bottom: 16px; padding: 0 16px; line-height: 1.6;">
            Уважаемые пользователи калькулятора, сервис работает в тестовом режиме, поэтому могут быть неточности в его ответах. Всегда проверяйте информацию в официальных документах опубликованных 
            <a 
              href="https://ba.hse.ru/dost" 
              target="_blank" 
              style="color: #6b7280; text-decoration: underline; font-size: 12px;"
              onmouseover="this.style.color='#4b5563';"
              onmouseout="this.style.color='#6b7280';"
            >в&nbsp;соответствующем разделе</a>.
            На время тестирования информация носит ориентировочный характер.
          </div>
        </div>

        <!-- New Info Panel (takes 1 column on large screens) -->
        <div class="widget-mt-8 widget-lg-mt-0 widget-space-y-6" style="margin-top: 8px">
          <!-- Info Panel -->
          <div
            class="widget-lg-sticky widget-lg-top-4"
            v-if="currentSegment !== 'calculator'"
          >
            <div class="sidebar-glass-card widget-bg-gray-100-80 widget-backdrop-blur-xl widget-rounded-2xl widget-p-6" style="padding: 24px !important;">
              <div class="widget-flex widget-items-center widget-gap-3 widget-mb-4">
                <div class="widget-p-2 widget-bg-blue-50 widget-rounded-lg" style="padding: 8px !important;">
                  <svg
                    class="widget-w-5 widget-text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <p class="heading-3 widget-text-lg widget-font-semibold widget-text-gray-900">
                  Важная информация
                </p>
              </div>

              <div class="widget-space-y-4 widget-text-sm widget-text-gray-600">
                <button 
                    @click="goToVideoGuide()"
                    class="widget-text-xs widget-link-purple widget-mt-2 widget-link-purple"
                  >
                    Видео-инструкция ↗
                  </button>
                <p>
                  Этот виджет предоставляет краткую информацию об индивидуальных
                  достижениях. Полный перечень и детальные правила учета
                  индивидуальных достижений доступны в официальных документах
                  НИУ ВШЭ.
                </p>

                <div class="widget-border-t widget-border-gray-200 widget-pt-4" style="padding-top: 16px !important;">
                  <a
                    href="https://ba.hse.ru/dost"
                    target="_blank"
                    class="widget-inline-flex widget-items-center widget-gap-2 widget-link-blue"
                  >
                    <span>Официальные документы</span>
                    <svg
                      class="widget-w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- Right sidebar -->
          <div
            class="widget-lg-sticky widget-lg-top-calc"
            v-if="currentSegment !== 'calculator'"
          >
            <!-- 64px (16px) for top spacing + height of info panel -->
            <div
              class="sidebar-glass-card widget-relative widget-bg-gray-100-80 widget-backdrop-blur-xl widget-rounded-2xl widget-p-6"
              style="padding: 24px !important;"
            >
              <div class="widget-relative widget--mt-19 widget--mb-4" style="margin-top: -3.5vh; margin-bottom: 1vh;">
                <img
                  src="@/assets/voronahse_wondering.png"
                  alt="Воронка думает"
                  class="widget-w-20 widget-object-contain widget--ml-2"
                />
              </div>

              <p class="heading-3 widget-text-lg widget-font-semibold widget-text-gray-900 widget-mb-4">
                А вы знали?
              </p>

              <p class="widget-text-sm widget-text-gray-600 widget-mb-4">
                {{ currentFact }}
              </p>

              <button
                @click="changeRandomFact"
                class="widget-text-sm widget-link-blue"
              >
                А ещё?
              </button>
            </div>
          </div>
          <div v-if="currentSegment === 'calculator'">
            <div class="widget-lg-sticky widget-lg-top-4">
              <div
                class="sidebar-glass-card widget-bg-gray-100-80 widget-backdrop-blur-xl widget-rounded-2xl widget-overflow-hidden"
              >
                <!-- Header section -->
                <div class="widget-p-6 widget-pb-0" style="padding: 24px !important; padding-bottom: 0px !important;">
                  <div class="widget-flex widget-items-center widget-gap-3 widget-mb-4">
                    <div class="widget-p-2 widget-bg-blue-50 widget-rounded-lg" style="padding: 8px !important;">
                      <svg
                        class="widget-w-5 widget-text-blue-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                        />
                      </svg>
                    </div>
                    <p class="heading-3 widget-text-lg widget-font-semibold widget-text-gray-900">
                      Калькулятор баллов
                    </p>
                  </div>
                </div>

                <!-- Main content with fixed height -->
                <div class="widget-flex widget-flex-col widget-h-screen-calc">
                  <!-- Scrollable Cart Items -->
                  <div class="widget-flex-1 widget-overflow-y-auto widget-px-6" style="padding-left: 24px !important; padding-right: 24px !important;">
                    <!-- Empty State -->
                    <div
                      v-if="cartItems.length === 0"
                      class="widget-text-sm widget-text-gray-500 widget-py-4"
                      style="padding-top: 16px !important; padding-bottom: 16px !important;"
                    >
                      Добавьте достижения, чтобы рассчитать сумму баллов
                    </div>

                    <!-- Cart Items -->
                    <div v-else class="widget-space-y-3 widget-py-4" style="padding-top: 16px !important; padding-bottom: 16px !important;">
                      <div
                        v-for="(items, category) in cartItemsByCategory"
                        :key="category"
                        class="widget-space-y-2"
                      >
                        <div
                          v-for="(item, index) in items"
                          :key="index"
                          class="widget-relative widget-bg-white widget-rounded-xl widget-p-4 widget-shadow-sm"
                          style="padding: 16px !important;"
                        >
                          <div class="widget-flex widget-justify-between widget-gap-4">
                            <div class="widget-flex-1">
                              <p class="heading-4 widget-text-sm widget-font-medium widget-text-gray-900">
                                {{ item.title }}
                                <span v-if="item.details && item.details.includes('Профиль:')" class="widget-text-sm widget-font-normal widget-text-gray-500 widget-ml-1">
                                  ({{ item.details.split('Профиль:')[1].split('\n')[0].trim() }})
                                </span>
                              </p>
                              <div v-if="item.points" class="widget-mt-1">
                                <span class="widget-text-sm widget-font-medium widget-text-blue-600">
                                  {{ item.points }} баллов
                                </span>
                              </div>
                            </div>
                            <button
                              @click="removeFromCart(cartItems.indexOf(item))"
                              class="widget-text-gray-400 widget-hover-red"
                              style="padding-top: 4px !important; padding-bottom: 4px !important;"
                            >
                              <svg
                                class="widget-w-5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                        <!-- Category max score -->
                        <div class="widget-text-xs widget-text-gray-500 widget-pb-2" style="padding-bottom: 8px !important;">
                          Учитывается максимальный балл в категории:
                          {{
                            Math.max(...items.map((item) => item.points || 0))
                          }}
                          баллов
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Fixed Total Section with padding -->
                  <div class="widget-px-6 widget-py-4 widget-border-t widget-border-gray-200 widget-bg-white-10" style="padding-left: 24px !important; padding-right: 24px !important; padding-top: 16px !important; padding-bottom: 16px !important;">
                    <div class="widget-flex widget-justify-between widget-items-center">
                      <span class="widget-text-sm widget-font-medium widget-text-gray-500"
                        >Итого баллов:</span
                      >
                      <span class="widget-text-lg widget-font-semibold widget-text-blue-600">{{
                        cartTotal
                      }}</span>
                    </div>
                    <p class="widget-mt-2 widget-text-xs widget-text-gray-500">
                      * Максимальная сумма баллов за индивидуальные достижения -
                      10
                    </p>
                  </div>
                </div>
                <!-- Add message bubble here -->
                <div
                  v-if="showEncouragement"
                  class="widget-relative widget-py-2 message-bubble-enter-active"
                  style="min-height: 40px; padding-top: 8px !important; padding-bottom: 8px !important;"
                  @click="dismissEcouragement"
                >
                  <div class="widget-flex widget-items-start widget-justify-start widget-gap-2">
                    <img
                      src="@/assets/voronahse_wondering.png"
                      alt="Воронка думает"
                      class="widget-w-12 widget-object-contain widget-z-10"
                    />
                    <div
                      class="widget-relative widget-bg-blue-50 widget-rounded-xl widget-p-3 widget-shadow-sm widget-max-w-280 widget-mb-1"
                      style="padding: 12px !important;"
                    >
                      <p class="widget-text-xs widget-text-blue-700 widget-leading-tight">
                        {{ currentEncouragement }}
                      </p>
                      <!-- Bubble tail -->
                      <div
                        class="widget-absolute widget-left-neg widget-bottom-3 widget-bubble-tail"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile Cart Modal -->
      <ion-modal
        :is-open="showCartModal"
        @didDismiss="closeCartModal"
        :breakpoints="[0, 1]"
        :initial-breakpoint="1"
        class="cart-modal"
      >
        <ion-header class="ion-no-border">
          <ion-toolbar>
            <ion-title>Калькулятор баллов</ion-title>
            <ion-buttons slot="end">
              <ion-button @click="closeCartModal">
                <ion-icon :icon="close"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>

        <div
          class="ion-padding"
          style="padding: 10px !important;"
        >
          <!-- Empty State -->
          <div
            v-if="cartItems.length === 0"
            class="widget-text-sm widget-text-gray-500 widget-py-4 widget-text-center"
            style="padding-top: 16px !important; padding-bottom: 16px !important;"
          >
            Добавьте достижения, чтобы рассчитать сумму баллов
          </div>

          <!-- Cart Items -->
          <div v-else class="widget-space-y-3">
            <div
              v-for="(items, category) in cartItemsByCategory"
              :key="category"
              class="widget-space-y-2"
            >
              <div
                v-for="(item, index) in items"
                :key="index"
                class="widget-relative widget-bg-white widget-rounded-xl widget-p-4 widget-shadow-sm"
                style="padding: 16px !important;"
              >
                <div class="widget-flex widget-justify-between widget-gap-4">
                  <div class="widget-flex-1">
                    <p class="heading-4 widget-text-sm widget-font-medium widget-text-gray-900">
                      {{ item.title }}
                      <span v-if="item.details && item.details.includes('Профиль:')" class="widget-text-sm widget-font-normal widget-text-gray-500 widget-ml-1">
                        ({{ item.details.split('Профиль:')[1].split('\n')[0].trim() }})
                      </span>
                    </p>
                    <div v-if="item.points" class="widget-mt-1">
                      <span class="widget-text-sm widget-font-medium widget-text-blue-600">
                        {{ item.points }} баллов
                      </span>
                    </div>
                  </div>
                  <ion-button
                    fill="clear"
                    color="danger"
                    @click="removeFromCart(cartItems.indexOf(item))"
                    style="padding-top: 4px !important; padding-bottom: 4px !important;"
                  >
                    <ion-icon :icon="trash" slot="icon-only"></ion-icon>
                  </ion-button>
                </div>
              </div>
              <div class="widget-text-xs widget-text-gray-500">
                Учитывается максимальный балл в категории:
                {{ Math.max(...items.map((item) => item.points || 0)) }} баллов
              </div>
            </div>
          </div>
        </div>

        <ion-footer class="ion-no-border">
          <ion-toolbar>
            <div class="widget-py-3"  style="padding: 15px !important; padding-bottom: 10px !important; padding-top: 12px !important; padding-bottom: 12px !important;">
              <div class="widget-flex widget-justify-between widget-items-center">
                <span class="widget-text-sm widget-font-medium widget-text-gray-500"
                  >Итого баллов:</span
                >
                <span class="widget-text-lg widget-font-semibold widget-text-blue-600">{{
                  cartTotal
                }}</span>
              </div>
              <p class="widget-mt-2 widget-text-xs widget-text-gray-500">
                * Максимальная сумма баллов за индивидуальные достижения - 10
              </p>
            </div>
          </ion-toolbar>
        </ion-footer>
      </ion-modal>

      <!-- Mobile Cart Button -->
      <div
        v-if="currentSegment === 'calculator'"
        class="widget-lg-hidden widget-fixed widget-bottom-6 widget-right-6 widget-z-50"
      >
        <button
          @click="openCartModal"
          class="widget-flex widget-items-center widget-justify-center widget-w-14 widget-bg-blue-600 widget-rounded-full widget-shadow-lg"
          style="transition: background-color 0.2s;"
        >
          <span
            v-if="cartItems.length > 0"
            class="widget-absolute widget-badge-pos widget-flex widget-items-center widget-justify-center widget-bg-red-500 widget-text-white widget-text-xs widget-font-bold widget-rounded-full widget-px-1"
          >
            {{ cartItems.length }}
          </span>
          <ion-icon
            :icon="folderOpenOutline"
            class="widget-w-6 widget-text-white"
          ></ion-icon>
        </button>
      </div>

      <!-- Add this new mobile toast component -->
      <div
        v-if="showEncouragement && isMobile"
        class="widget-fixed widget-bottom-6 widget-left-4 widget-right-4 widget-z-50 animate-slide-up"
      >
        <div
          class="toast-container widget-toast-container"
          style="padding: 16px !important;"
        >
          <div class="rainbow-gradient"></div>
          <div class="widget-flex widget-items-center widget-gap-3 widget-relative widget-z-10">
            <img
              src="@/assets/voronahse_wondering.png"
              alt="Воронка"
              class="widget-w-12 widget-object-contain"
            />
            <p class="widget-text-sm widget-font-medium widget-text-gray-800">
              {{ currentEncouragement }}
            </p>
          </div>
        </div>
      </div>
      
    </div>
  </div>

  <!-- Add the Feature Showcase Modal -->
  <feature-showcase-modal
    :is-open="showFeatureModal"
    @didDismiss="handleFeatureModalDismiss"
  />

  <!-- Review Modal -->
  <ion-modal 
    :is-open="showReviewModal" 
    @didDismiss="showReviewModal = false"
    css-class="review-modal"
  >
    <div class="review-modal-content ion-padding" style="padding: 24px !important;">
      <ion-button fill="clear" class="close-button" @click="showReviewModal = false">
        <ion-icon slot="icon-only" :icon="close"></ion-icon>
      </ion-button>

      <div v-if="!reviewSubmitted">
        <img src="@/assets/voronahse_cute.png" alt="Воронка" class="review-modal-image"/>
        <p class="heading-3 review-modal-title">Помогите нам стать лучше!</p>
        <p class="review-modal-text widget-mb-4">
          Мы постоянно работаем над улучшением виджета и нам очень важно ваше мнение. Расскажите, что вам понравилось, а что можно улучшить. Ваша обратная связь поможет нам сделать виджет еще удобнее для будущих абитуриентов.
        </p>
        <br/>
        
        <a 
          href="https://forms.yandex.ru/cloud/682b21eeeb61466260c0c098/"
          target="_blank"
          class="widget-w-full widget-mt-4 widget-btn-primary widget-bg-blue-500 widget-text-white widget-rounded-xl widget-py-3 widget-inline-block widget-text-center"
        >
          Оставить отзыв
        </a>
        
        <button 
          @click="closeReviewModal" 
          class="widget-w-full widget-mt-3 widget-btn-secondary widget-rounded-xl widget-py-3 widget-text-gray-600"
          style="padding-top: 12px !important; padding-bottom: 12px !important;"
        >
          Закрыть
        </button>
      </div>

      <div v-else class="widget-text-center widget-py-6" style="padding-top: 24px !important; padding-bottom: 24px !important;">
        <div class="widget-w-16 widget-bg-green-100 widget-rounded-full widget-flex widget-items-center widget-justify-center widget-mx-auto widget-mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="widget-w-8 widget-text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p class="heading-3 widget-text-xl widget-font-medium widget-text-gray-900 widget-mb-2">Спасибо за ваш отзыв!</p>
        <p class="widget-text-gray-600">Мы ценим вашу обратную связь, она поможет нам улучшить виджет.</p>
        <button 
          @click="closeReviewModal" 
          class="widget-mt-6 widget-px-6 widget-py-2 widget-btn-secondary widget-rounded-lg widget-text-gray-800"
          style="padding-top: 12px !important; padding-bottom: 12px !important;"
        >
          Закрыть
        </button>
      </div>
    </div>
  </ion-modal>

  <!-- Achievement Unlocked Popup (HSE University Style with Voronka) -->
  <transition name="achievement-popup">
    <div 
      v-if="showAchievementPopup && achievementPopupData"
      @click="hideAchievementPopup"
      style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 51, 102, 0.85);
        backdrop-filter: blur(12px);
        cursor: pointer;
      "
    >
      <!-- Achievement Card - HSE Blue Theme -->
      <div 
        class="achievement-card-animated"
        style="
          position: relative;
          max-width: 400px;
          width: 90%;
          padding: 32px 28px 28px 28px;
          background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
          border-radius: 28px;
          border: 3px solid #0066CC;
          box-shadow: 
            0 0 80px rgba(0, 102, 204, 0.4),
            0 20px 60px rgba(0, 0, 0, 0.2),
            inset 0 1px 0 rgba(255, 255, 255, 1);
          text-align: center;
          overflow: hidden;
        "
      >
        <!-- HSE Blue gradient accent at top -->
        <div 
          style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 6px;
            background: linear-gradient(90deg, #0066CC 0%, #0052A3 50%, #0066CC 100%);
          "
        ></div>

        <!-- Animated glow effect - HSE Blue -->
        <div 
          class="achievement-glow"
          style="
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: conic-gradient(from 0deg, transparent, rgba(0, 102, 204, 0.08), transparent, rgba(0, 102, 204, 0.08), transparent);
            animation: rotate-glow 4s linear infinite;
            pointer-events: none;
          "
        ></div>

        <!-- Voronka Mascot -->
        <div style="position: relative; z-index: 1; margin-bottom: 12px; margin-top: 8px;">
          <div 
            class="trophy-bounce"
            style="
              width: 100px;
              height: 100px;
              margin: 0 auto;
              position: relative;
            "
          >
            <img
              src="@/assets/voronahse_cute.png"
              alt="Воронка"
              style="
                width: 100%;
                height: 100%;
                object-fit: contain;
                filter: drop-shadow(0 8px 20px rgba(0, 102, 204, 0.3));
              "
            />
            <!-- Celebration sparkles around Voronka -->
            <div style="position: absolute; top: -5px; right: 5px; font-size: 20px; animation: sparkle 1s ease-in-out infinite;">✨</div>
            <div style="position: absolute; top: 10px; left: 0px; font-size: 16px; animation: sparkle 1s ease-in-out infinite 0.3s;">⭐</div>
            <div style="position: absolute; bottom: 15px; right: -5px; font-size: 14px; animation: sparkle 1s ease-in-out infinite 0.6s;">🎉</div>
          </div>
        </div>

        <!-- Achievement Unlocked Text -->
        <div style="position: relative; z-index: 1;">
          <p 
            style="
              font-size: 11px;
              font-weight: 700;
              letter-spacing: 2px;
              text-transform: uppercase;
              color: #0066CC;
              margin: 0 0 10px 0;
            "
          >
            🎓 Достижение добавлено 🎓
          </p>
          
          <!-- Achievement Title -->
          <p
            class="heading-2"
            style="
              font-size: 20px;
              font-weight: 700;
              color: #1e293b;
              margin: 0 0 16px 0;
              line-height: 1.35;
              padding: 0 8px;
            "
          >
            {{ achievementPopupData.title }}
          </p>

          <!-- Points Badge - HSE Style -->
          <div 
            style="
              display: inline-flex;
              align-items: center;
              gap: 6px;
              padding: 14px 28px;
              background: linear-gradient(135deg, #0066CC 0%, #0052A3 100%);
              border-radius: 50px;
              box-shadow: 0 4px 20px rgba(0, 102, 204, 0.35);
            "
          >
            <span style="font-size: 32px; font-weight: 800; color: #ffffff;">
              +{{ achievementPopupData.points }}
            </span>
            <span style="font-size: 15px; font-weight: 600; color: rgba(255, 255, 255, 0.9);">
              баллов
            </span>
          </div>

          <!-- Voronka message -->
          <p 
            style="
              margin-top: 18px;
              font-size: 13px;
              color: #64748b;
              font-style: italic;
            "
          >
            « Молодец! Так держать! »
          </p>

          <!-- Tap to dismiss hint -->
          <p 
            style="
              margin-top: 12px;
              font-size: 11px;
              color: #94a3b8;
            "
          >
            Нажмите, чтобы закрыть
          </p>
        </div>

        <!-- Decorative confetti particles - HSE Blue -->
        <div class="particles" style="position: absolute; inset: 0; overflow: hidden; pointer-events: none; z-index: 0;">
          <div class="particle" style="position: absolute; width: 10px; height: 10px; background: #0066CC; border-radius: 50%; top: 15%; left: 8%; animation: float-particle 2s ease-in-out infinite; opacity: 0.6;"></div>
          <div class="particle" style="position: absolute; width: 8px; height: 8px; background: #0052A3; border-radius: 50%; top: 25%; right: 12%; animation: float-particle 2.5s ease-in-out infinite 0.5s; opacity: 0.5;"></div>
          <div class="particle" style="position: absolute; width: 6px; height: 6px; background: #0066CC; border-radius: 50%; bottom: 20%; left: 15%; animation: float-particle 1.8s ease-in-out infinite 0.3s; opacity: 0.7;"></div>
          <div class="particle" style="position: absolute; width: 12px; height: 12px; background: #3b82f6; border-radius: 50%; bottom: 30%; right: 20%; animation: float-particle 2.2s ease-in-out infinite 0.7s; opacity: 0.4;"></div>
          <div class="particle" style="position: absolute; width: 7px; height: 7px; background: #0066CC; border-radius: 50%; top: 40%; left: 5%; animation: float-particle 2.8s ease-in-out infinite 0.2s; opacity: 0.5;"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonSearchbar,
  IonList,
  IonItem,
  IonLabel,
  IonModal,
  IonButtons,
  IonButton,
  IonIcon,
  IonFooter,
} from "@ionic/vue";
import { defineComponent } from "vue";
import type { Program, Olympiad, Profile } from "@/types/program";
import { parseAchievementsWorkbook } from "@/utils/achievementsWorkbook";
import * as XLSX from "xlsx";
import { close, trash, folderOpenOutline } from "ionicons/icons";

import { Preferences } from "@capacitor/preferences";
import FeatureShowcaseModal from '@/components/FeatureShowcaseModal.vue';
import CustomSegment from '@/components/CustomSegment.vue';

interface OlympiadProfile {
  name: string;
  profile: string;
  level: number;
}

interface OlympiadData {
  name: string;
  profiles?: OlympiadProfile[];
  campus?: string;
  type?: string; // Add this line
}

interface ProgramWithBenefits {
  title: string;
  megaTag: string;
  benefits: string;
}

export default defineComponent({
  name: "HomePage",
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonSearchbar,
    IonList,
    IonItem,
    IonLabel,
    IonModal,
    IonButtons,
    IonButton,
    IonIcon,
    IonFooter,
    FeatureShowcaseModal,
    CustomSegment,
  },
  props: {
    domain: {
      type: String,
      required: true
    },
    storageUri: {
      type: String,
      required: true,
      default: ""
    },
    // Add new prop for app mode
    isApp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataDomain: "",
      currentSegment: "view_all", // Ensure this is set to "view_all"
      programsData: [] as Program[],
      searchQuery: "",
      showSuggestions: true,
      selectedCampus: "all", // Add this line
      olympiadsData: [] as Olympiad[],
      profilesData: [] as Profile[],
      programsList: [] as { title: string; megaTag: string }[],
      selectedGrade: "",
      selectedProfile: "",
      combinedData: [] as Array<Program | Olympiad>,
      funFacts: [
        "В Вышке учились более 100 олимпийских медалистов!",
        "Первый выпуск ВШЭ состоял всего из 38 студентов",
        "Корпус на Покровском бульваре построен в XIX веке",
        "В Вышке более 40000 студентов",
        "HSE University входит в топ-100 молодых университетов мира",
        "Первоначально Вышка называлась «Высшая школа экономики при Министерстве науки»",
        "В библиотеке Вышки более миллиона книг",
        "Вышка была основана в 1992 году",
      ],
      currentFact: "",
      showProgramModal: false,
      programSearchQuery: "",
      selectedProgramName: "",
      modalSelectedCampus: "all",
      calculatorSearchQuery: "",
      cartItems: [] as Array<{
        title: string;
        points: number;
        details?: string;
        category?: string; // Add category field
      }>,
      filterCategory: "popular", // Set default filter category to 'all'

      // Arrays to store achievement titles
      popularAchievements: [
        "Аттестат с отличием",
        "Волонтерская деятельность",
        "Золотой знак ГТО",
      ], // Replace with actual titles
      hseContestsList: ["Своими словами", "Высший пилотаж", "Высшая проба"], // Replace with actual contest names
      encouragementMessages: [
        "Вау, какое у вас крутое достижение!",
        "Отличный выбор! Так держать!",
        "Это достижение точно поможет при поступлении!",
        "Я в восторге от ваших достижений!",
        "Вы молодец! Продолжайте в том же духе!",
        "С такими достижениями вам открыты все двери!",
        "Блестящее достижение! Горжусь вами!",
        "Вот это да! Вы очень целеустремленный человек!",
      ],
      currentEncouragement: "",
      showEncouragement: false,
      showCartModal: false,
      isMobile: false,
      enteredPassword: "",
      isPageLockedAndRequiresPassword: false,
      accessPassword: "admin123admin123",
      showFeatureModal: false, // Add state for the modal
      resizeObserver: null, // Add missing comma
      showParseLogs: false, // Add flag for parse logs
      isLoadingData: true,
      isLoadError: false,
      // Descriptions for filter segments
      segmentDescriptions: {
        popular: 'Достижения, которые ищут чаще всего пользователи этого виджета',
        regional_vso: 'Покажет, какие дипломы регионального этапа Всероссийской олимпиады школьников учитываются для выбранной программы',
        hse_contests: 'Олимпиады и конкурсы, организуемые непосредственно Вышка, которые дают баллы индивидуальных достижений при поступлении в НИУ ВШЭ ',
        olympiads: 'Все олимпиады, которые дают баллы индивидуальных достижений при поступлении в Вышку, в том числе и олимпиады перечня РСОШ',
        all: 'Показывает все индивидуальные достижения, доступные для выбранной программы.'
      },
      showReviewModal: false,
      infoBannerExpanded: false,
      // Add new state variables for school prompt
      isTestingOnSchools: false,
      enteredSchoolName: "",
      hasEnteredSchoolName: false,
      // Add new state variables for review
      reviewText: "",
      reviewSubmitted: false,
      // Achievement popup state
      showAchievementPopup: false,
      achievementPopupData: null as { title: string; points: number; category?: string } | null,
    };
  },
  computed: {
    isOlympiadSelected(): boolean {
      // Determine if the search query matches an Olympiad
      return this.olympiadNames.includes(this.searchQuery);
    },
    olympiadNames(): string[] {
      return this.olympiadsData.map((o) => o.name);
    },
    suggestions(): string[] {
      if (!this.searchQuery) return [];
      const normalizedQuery = this.normalizeText(this.searchQuery);
      return [
        ...new Set(
          this.combinedData
            .filter((item) => item && item.title)
            .filter((item) =>
              this.normalizeText(item.title).includes(normalizedQuery)
            )
            .map((item) => item.title)
        ),
      ].slice(0, 5);
    },
    availableProfiles(): string[] {
      if (!this.searchQuery || !this.isOlympiadSelected) return [];
      const olympiad = this.olympiadsData.find(
        (o) => o.name === this.searchQuery
      );
      return [...new Set(olympiad?.profiles?.map((p) => p.profile) || [])];
    },
    exactMatchExists(): boolean {
      if (!this.searchQuery) return false;
      const normalizedQuery = this.normalizeText(this.searchQuery);
      return this.combinedData.some(
        (item) =>
          item &&
          item.title &&
          this.normalizeText(item.title) === normalizedQuery
      );
    },
    groupedResults(): Record<string, Array<any>> | null {
      if (
        !this.searchQuery ||
        (!this.exactMatchExists && !this.isOlympiadSelected)
      )
        return null;

      if (this.isOlympiadSelected) {
        if (!this.selectedGrade || !this.selectedProfile) {
          return null;
        }

        const olympiad = this.olympiadsData.find(
          (o) => o.name === this.searchQuery
        );
        if (olympiad) {
          const matchingProfiles = olympiad.profiles?.filter(
            (p) =>
              this.normalizeText(p.profile) ===
              this.normalizeText(this.selectedProfile)
          );

          if (matchingProfiles?.length) {
            const groupedByCampus: Record<string, Array<any>> = {};

            let matchingPrograms = this.programsList.filter((program) => {
              if (!program.megaTag) return false; // Add this check

              if (program.megaTag === "All") {
                // Special case: Don't include "Высший пилотаж" in universal rules
                if (olympiad.name.includes("Высший пилотаж")) {
                  return false;
                }
                // Only include HARD type olympiads for universal rules
                return olympiad.type === "HARD";
              }

              const conditions = program.megaTag.split(";").map((condition) => {
                // Add null check for condition
                if (!condition) return { key: "", value: "" };

                const [key = "", value = ""] = condition.split(":");
                return { key, value };
              });

              const hasOlympiadCondition = conditions.some(
                (cond) => cond.key === "Olympiad"
              );

              // For "Высший пилотаж", only match if explicitly specified in megaTag
              if (
                olympiad.name.includes("Высший пилотаж") &&
                !hasOlympiadCondition
              ) {
                return false;
              }

              // If no Olympiad condition is specified, allow any HARD olympiad
              if (!hasOlympiadCondition) {
                return (
                  olympiad.type === "HARD" &&
                  conditions.every(({ key, value }) => {
                    if (!value) return true;
                    const normalizedValues = value
                      .split(",")
                      .map((v) => this.normalizeText(v.trim()));

                    switch (key) {
                      case "Profile":
                        return normalizedValues.includes(
                          this.normalizeText(this.selectedProfile)
                        );
                      case "Level":
                        const levels = normalizedValues.map(Number);
                        return matchingProfiles.some((p) =>
                          levels.includes(p.level)
                        );
                      case "Grade":
                        return normalizedValues.includes(
                          this.normalizeText(this.selectedGrade)
                        );
                      default:
                        return true;
                    }
                  })
                );
              }

              // If Olympiad is specified, check all conditions including Olympiad match
              return conditions.every(({ key, value }) => {
                if (!value) return true;
                const normalizedValues = value
                  .split(",")
                  .map((v) => this.normalizeText(v.trim()));

                switch (key) {
                  case "Profile":
                    return normalizedValues.includes(
                      this.normalizeText(this.selectedProfile)
                    );
                  case "Level":
                    const levels = normalizedValues.map(Number);
                    return matchingProfiles.some((p) =>
                      levels.includes(p.level)
                    );
                  case "Grade":
                    return normalizedValues.includes(
                      this.normalizeText(this.selectedGrade)
                    );
                  case "Olympiad":
                    return normalizedValues.includes(
                      this.normalizeText(olympiad.name)
                    );
                  default:
                    return true;
                }
              });
            });

            if (this.selectedCampus !== "all") {
              matchingPrograms = matchingPrograms.filter(
                (program) =>
                  this.normalizeText(program.campus) ===
                    this.normalizeText(this.selectedCampus) ||
                  program.campus === "all"
              );
            }

            const programMap = new Map();

            matchingPrograms.forEach((program) => {
              const campus = program.campus || "Другое";
              const key = `${campus}-${program.title}`;

              console.log(`Debug - Processing program:`, {
                key,
                campus,
                title: program.title,
                benefits: program.benefits,
                megaTag: program.megaTag,
              });

              if (!programMap.has(key)) {
                programMap.set(key, {
                  campus,
                  title: program.title,
                  benefits: new Set([program.benefits]),
                  details: program.details,
                });
                console.log(
                  `Debug - Created new entry for ${key}:`,
                  programMap.get(key)
                );
              } else {
                const existing = programMap.get(key);
                console.log(`Debug - Before adding to existing ${key}:`, {
                  existingBenefits: Array.from(existing.benefits),
                  newBenefit: program.benefits,
                });
                existing.benefits.add(program.benefits);
                console.log(
                  `Debug - After adding:`,
                  Array.from(existing.benefits)
                );
              }
            });

            programMap.forEach(({ campus, title, benefits, details }, key) => {
              if (!groupedByCampus[campus]) {
                groupedByCampus[campus] = [];
              }

              const benefitsArray = Array.from(benefits).join("\n");
              console.log(`Debug - Final benefits for ${title}:`, {
                benefits: Array.from(benefits),
                joinedBenefits: benefitsArray,
              });

              groupedByCampus[campus].push({
                title,
                benefits: benefitsArray,
                campus,
                details: `Профиль: ${this.selectedProfile}\nКласс: ${this.selectedGrade}`,
                olympiadProfile: this.selectedProfile,
                type: "Olympiad"
              });
            });

            return Object.keys(groupedByCampus)
              .sort()
              .reduce((acc, campus) => {
                acc[campus] = groupedByCampus[campus];
                return acc;
              }, {} as Record<string, Array<any>>);
          }
        }
        return null;
      }

      // Regular search logic with case-insensitive filtering
      let filtered = this.combinedData.filter(
        (item) =>
          item &&
          item.title &&
          this.normalizeText(item.title) ===
            this.normalizeText(this.searchQuery)
      );

      if (this.selectedCampus !== "all") {
        filtered = filtered.filter(
          (item) =>
            this.normalizeText(item.campus) ===
              this.normalizeText(this.selectedCampus) || item.campus === "all"
        );
      }

      // Create a map to merge duplicates
      const mergedMap = new Map();

      filtered.forEach((item) => {
        const campus = item.campus || "Все кампусы";
        const key = `${campus}-${item.title}`;

        if (!mergedMap.has(key)) {
          mergedMap.set(key, {
            campus,
            items: [{ ...item }],
          });
        } else {
          const existing = mergedMap.get(key);
          existing.items.push({ ...item });
        }
      });

      // Convert map back to grouped object
      const grouped = Array.from(mergedMap.entries()).reduce(
        (acc, [key, value]) => {
          const { campus, items } = value;

          if (!acc[campus]) {
            acc[campus] = [];
          }

          // Merge items with same title
          const mergedItem = {
            ...items[0],
            benefits: Array.from(
              new Set(items.filter((i) => i.benefits).map((i) => i.benefits))
            ).join("\n"),
          };

          acc[campus].push(mergedItem);
          return acc;
        },
        {} as Record<string, Array<any>>
      );

      return Object.keys(grouped).length > 0 ? grouped : null;
    },
    uniqueProgramNames(): string[] {
      const titleMap = new Map<string, string>();
      this.programsList.forEach((p) => {
        const normalizedTitle = this.normalizeText(p.title);
        if (!titleMap.has(normalizedTitle)) {
          titleMap.set(normalizedTitle, p.title.trim());
        }
      });
      return [...titleMap.values()].sort();
    },
    filteredPrograms(): string[] {
      console.log("Computing filteredPrograms:", {
        query: this.programSearchQuery,
        uniquePrograms: this.uniqueProgramNames
      });
      
      if (!this.programSearchQuery) return this.uniqueProgramNames;
      const query = this.normalizeText(this.programSearchQuery);
      const filtered = this.uniqueProgramNames.filter((program) =>
        this.normalizeText(program).includes(query)
      );
      
      console.log("Filtered programs result:", filtered.length, "programs");
      return filtered;
    },
    groupedPrograms(): Record<string, string[]> {
      console.log("Computing groupedPrograms with:", {
        filteredPrograms: this.filteredPrograms,
        modalSelectedCampus: this.modalSelectedCampus,
        programsList: this.programsList
      });

      const programs = this.filteredPrograms;
      const grouped: Record<string, Set<string>> = {
        all: new Set(),
        Москва: new Set(),
        "Санкт-Петербург": new Set(),
        "Нижний Новгород": new Set(),
        Пермь: new Set(),
      };

      // Map to store normalized titles and their actual titles
      const titleMap = new Map<string, string>();
      
      // Collect campuses for each program
      const programCampuses = new Map<string, Set<string>>();
      
      console.log("Processing programsList:", this.programsList.length, "items");
      
      this.programsList.forEach((program) => {
        if (!program.title) {
          console.warn("Program without title:", program);
          return;
        }
        
        const normalizedTitle = this.normalizeText(program.title);
        // Store the first encountered original title
        if (!titleMap.has(normalizedTitle)) {
          titleMap.set(normalizedTitle, program.title.trim());
        }
        
        const campus = program.campus || "all";
        if (!programCampuses.has(normalizedTitle)) {
          programCampuses.set(normalizedTitle, new Set());
        }
        programCampuses.get(normalizedTitle)?.add(campus);
      });

      console.log("Program campuses map:", {
        size: programCampuses.size,
        sample: Array.from(programCampuses.entries()).slice(0, 3)
      });

      // Sort programs into their respective campus groups
      programs.forEach((programTitle) => {
        const normalizedTitle = this.normalizeText(programTitle);
        const campuses = programCampuses.get(normalizedTitle);
        
        if (!campuses) {
          console.warn("No campuses found for program:", programTitle);
          return;
        }

        const actualTitle = titleMap.get(normalizedTitle) || programTitle;

        console.log("Processing program:", {
          title: actualTitle,
          campuses: Array.from(campuses),
          modalSelectedCampus: this.modalSelectedCampus
        });

        if (this.modalSelectedCampus === "all") {
          if (campuses.has("all")) {
            grouped["all"].add(actualTitle);
          } else {
            campuses.forEach((campus) => {
              if (campus !== "all") {
                grouped[campus].add(actualTitle);
              }
            });
          }
        } else {
          // When specific campus is selected
          if (campuses.has("all") || campuses.has(this.modalSelectedCampus)) {
            grouped[this.modalSelectedCampus].add(actualTitle);
          }
        }
      });

      // Convert Sets to arrays and sort them
      const result: Record<string, string[]> = {};
      Object.keys(grouped).forEach((campus) => {
        result[campus] = Array.from(grouped[campus]).sort();
      });

      console.log("Final grouped programs:", result);
      return result;
    },
    calculatorResults(): Record<string, Array<any>> | null {
      if (!this.selectedProgramName) return null;

      console.log(
        `Calculating results for: ${this.selectedProgramName} (${this.selectedCampus})`
      );

      // Get base achievements
      let achievements = this.programsData.filter((item) => {
        const isUniversal =
          item.program_name === "all" && item.campus === "all";
        const isProgramSpecific =
          item.program_name === this.selectedProgramName &&
          (item.campus === "all" || item.campus === this.selectedCampus);

        if (isUniversal || isProgramSpecific) {
          console.log(`Including achievement: ${item.title} (${item.campus})`);
          return true;
        }
        return false;
      });

      // Find program-specific olympiads with campus consideration
      const olympiadEntries = this.programsList.filter((program) => {
        if (!program?.megaTag) return false;

        const isSameCampus = program.campus === this.selectedCampus;
        const isSameProgram =
          this.normalizeText(program.title) ===
          this.normalizeText(this.selectedProgramName);

        if (isSameProgram && isSameCampus) {
          console.log(
            `Found matching olympiad entry for: ${program.title} (${program.campus})`
          );
          return true;
        }
        return false;
      });

      // Extract olympiad data with consistent category mapping
      let olympiads = olympiadEntries
        .map((entry) => {
          if (!entry.megaTag) return null;

          const params = entry.megaTag.split(";").reduce((acc, part) => {
            const [key, value] = part.split(":").map((s) => s?.trim());
            if (key && value) {
              acc[key] = value
                .split(",")
                .map((v) => v.trim())
                .join(", ");
            }
            return acc as Record<string, string>;
          }, {} as Record<string, string>);

          if (!params.Olympiad) return null;

          // Create separate entries for each profile if multiple profiles are specified
          if (params.Profile && params.Profile.includes(",")) {
            // Multiple profiles case - create multiple entries
            const profiles = params.Profile.split(",").map(p => p.trim());
            return profiles.map(profile => {
              let details = entry.details || "";
              details += (details ? "\n" : "") + `Профиль: ${profile}`;
              if (params.Grade) {
                details += (details ? "\n" : "") + `Класс: ${params.Grade}`;
              }

              // Extract points using regex - this will find any number in the benefits text
              const pointsMatch = entry.benefits?.match(/\d+/);
              const points = pointsMatch ? parseInt(pointsMatch[0]) : 0;

              let category = "Olympiad";
              if (entry.benefits?.toLowerCase().includes("региональный этап")) {
                category = "Региональный этап ВсОШ";
              }

              return {
                name: params.Olympiad,
                title: `${params.Olympiad}`, // Just the olympiad name
                points: points,
                details: details,
                benefits: entry.benefits,
                category: category,
                type: "Olympiad",
                olympiadProfile: profile
              };
            });
          } else {
            // Single profile case
            let details = entry.details || "";
            if (params.Profile) {
              details += (details ? "\n" : "") + `Профиль: ${params.Profile}`;
            }
            if (params.Grade) {
              details += (details ? "\n" : "") + `Класс: ${params.Grade}`;
            }

            // Extract points using regex - this will find any number in the benefits text
            const pointsMatch = entry.benefits?.match(/\d+/);
            const points = pointsMatch ? parseInt(pointsMatch[0]) : 0;

            let category = "Olympiad";
            if (entry.benefits?.toLowerCase().includes("региональный этап")) {
              category = "Региональный этап ВсОШ";
            }

            return {
              name: params.Olympiad,
              title: `${params.Olympiad}`, // Just the olympiad name
              points: points,
              details: details,
              benefits: entry.benefits,
              category: category,
              type: "Olympiad",
              olympiadProfile: params.Profile
            };
          }
        })
        .filter(Boolean);
        
      // Flatten the array in case there were multiple profiles
      olympiads = olympiads.flat();

      // Map categories for basic achievements
      achievements = achievements.map((item) => ({
        ...item,
        category:
          item.type === "Олимпиады"
            ? item.title.includes("региональный этап")
              ? "Региональный этап ВсОШ"
              : this.hseContestsList.some((contest) =>
                  item.title.includes(contest)
                )
              ? "Организованно ВШЭ"
              : "Олимпиады"
            : item.category || "Индивидуальные достижения",
      }));

      // Combine achievements and olympiads
      achievements = [...achievements, ...olympiads];

      // Apply search filter if needed
      if (this.calculatorSearchQuery) {
        const searchQuery = this.normalizeText(this.calculatorSearchQuery);
        achievements = achievements.filter((item) =>
          this.normalizeText(item.title).includes(searchQuery)
        );
      }
      // Only apply category filter if there's no search query
      else if (this.filterCategory && this.filterCategory !== "all") {
        switch (this.filterCategory) {
          case "popular":
            achievements = achievements.filter((item) =>
              this.popularAchievements.includes(item.title)
            );
            break;
          case "regional_vso":
            achievements = achievements.filter((item) =>
              item.title
                .toLowerCase()
                .includes(
                  "всероссийская олимпиада школьников (региональный этап)"
                )
            );
            break;
          case "hse_contests":
            achievements = achievements.filter((item) =>
              this.hseContestsList.some((contest) =>
                item.title.includes(contest)
              )
            );
            break;
          case "olympiads":
            achievements = achievements.filter(
              (item) =>
                item.category === "Олимпиады" || item.category === "Olympiad"
            );
            break;
        }
      }

      // Before grouping by category, deduplicate achievements
      achievements = achievements.reduce((unique, item) => {
        // Create a unique key based on all relevant properties
        const key = JSON.stringify({
          title: item.title,
          points: item.points,
          details: item.details,
          benefits: item.benefits,
          category: item.category
        });

        // If this exact item doesn't exist yet, add it
        if (!unique.some(existingItem => 
          JSON.stringify({
            title: existingItem.title,
            points: existingItem.points,
            details: existingItem.details,
            benefits: existingItem.benefits,
            category: existingItem.category
          }) === key
        )) {
          unique.push(item);
        }
        return unique;
      }, [] as Array<any>);

      // Group by category (existing code)
      const grouped = achievements.reduce((acc, item) => {
        const category = item.category || "Индивидуальные достижения";
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(item);
        return acc;
      }, {} as Record<string, Array<any>>);

      // Sort groups and items within groups
      return Object.keys(grouped)
        .sort()
        .reduce((acc, key) => {
          acc[key] = grouped[key].sort((a, b) => {
            if (b.points !== a.points) {
              return b.points - a.points;
            }
            return a.title.localeCompare(b.title);
          });
          return acc;
        }, {} as Record<string, Array<any>>);
    },

    cartTotal(): number {
      // Group items by category
      const categoryGroups = this.cartItems.reduce((acc, item) => {
        const category = item.category || "uncategorized";
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(item);
        return acc;
      }, {} as Record<string, Array<any>>);

      // For each category, take only the highest score
      const totalScore = Object.values(categoryGroups).reduce((sum, items) => {
        const maxScoreInCategory = Math.max(
          ...items.map((item) => item.points || 0)
        );
        return sum + maxScoreInCategory;
      }, 0);

      return Math.min(totalScore, 10); // Cap at 10 points
    },

    cartItemsByCategory(): Record<string, Array<any>> {
      return this.cartItems.reduce((acc, item) => {
        const category = item.category || "Другое";
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(item);
        return acc;
      }, {} as Record<string, Array<any>>);
    },
  },
  watch: {
    showProgramModal(newVal) {
      if (newVal) document.body.style.overflow = "hidden";
      else document.body.style.overflow = "";
    },
    showCartModal(newVal) {
      if (newVal) document.body.style.overflow = "hidden";
      else document.body.style.overflow = "";
    },
    searchQuery() {
      this.changeRandomFact();
      this.$nextTick(() => this.updateParentHeight());
    },
    selectedProgramName() {
      this.$nextTick(() => this.updateParentHeight());
    },
    cartItems: {
      handler() {
        this.$nextTick(() => this.updateParentHeight());
      },
      deep: true
    },
    showProgramModal(newVal) {
      if (!newVal) {
        this.$nextTick(() => this.updateParentHeight());
      }
    },
  },
  methods: {
  goToVideoGuide(){
    //new tab for goToVideoGuide
    if (window != null){
       window.open("https://vkvideo.ru/video-230231142_456239018", '_blank').focus();
    }

  },
    // Add this new method
    updateParentHeight() {
      console.log('Updating parent height');
      try {
        // Use the body's scrollHeight
        const height = document.body.scrollHeight;
        console.log('Computed body scrollHeight:', height);

        // Send the height to the parent
        window.parent.postMessage({ height }, '*');
      } catch (error) {
        console.error('Error sending height update:', error);
      }
    },
    checkPassword(){
      if (this.accessPassword === this.enteredPassword) {
        this.isPageLockedAndRequiresPassword = false;
        localStorage.setItem("accessPassword", "" + this.enteredPassword);
      }else{
        alert("Incorrect password.")
      }
    },
    // Add new methods for school name submission
    async submitSchoolName() {
      if (!this.enteredSchoolName.trim()) {
        alert("Пожалуйста, введите название школы.");
        return;
      }
      
      try {
        // Send school name to the API
        const response = await fetch('https://sys.internal.deqstudio.com/hsewidget/index.php/visitorregister', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            'school_name': this.enteredSchoolName.trim()
          })
        });
        
        if (response.ok) {
          // Save to localStorage
          localStorage.setItem("testingSchoolName", this.enteredSchoolName.trim());
          this.hasEnteredSchoolName = true;
        } else {
          console.error("Failed to register school:", await response.text());
          // Still proceed even if API fails
          localStorage.setItem("testingSchoolName", this.enteredSchoolName.trim());
          this.hasEnteredSchoolName = true;
        }
      } catch (error) {
        console.error("Error submitting school name:", error);
        // Still proceed even if API fails
        localStorage.setItem("testingSchoolName", this.enteredSchoolName.trim());
        this.hasEnteredSchoolName = true;
      }
    },
    // Enhanced review submission
    async submitReview() {
      if (!this.reviewText.trim()) {
        alert("Пожалуйста, введите текст отзыва.");
        return;
      }
      
      try {
        // Get school name from localStorage or use "unknown"
        const schoolName = localStorage.getItem("testingSchoolName") || "unknown";
        
        // Send review to the API
        const response = await fetch('https://sys.internal.deqstudio.com/hsewidget/index.php/leavereview', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            'school_name': schoolName,
            'review': this.reviewText.trim()
          })
        });
        
        if (response.ok) {
          this.reviewSubmitted = true;
        } else {
          console.error("Failed to submit review:", await response.text());
          // Still show success even if API fails
          this.reviewSubmitted = true;
        }
      } catch (error) {
        console.error("Error submitting review:", error);
        // Still show success even if API fails
        this.reviewSubmitted = true;
      }
    },
    closeReviewModal() {
      this.showReviewModal = false;
      this.reviewSubmitted = false;
      this.reviewText = "";
    },
    normalizeText(text: string): string {
      return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();
    },
    async loadExcelData() {
      this.isLoadingData = true;
      this.isLoadError = false;

      try {
        const dataUrl = `${this.storageUri.replace(/\/$/, "")}/${this.dataDomain}_AchievementsDatatable.xlsx`;
        if (this.showParseLogs) console.log(`Loading achievements data from ${dataUrl}...`);

        const response = await fetch(dataUrl, { cache: "no-store" });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const arrayBuffer = await response.arrayBuffer();
        const workbook = XLSX.read(new Uint8Array(arrayBuffer), { type: "array" });
        const payload = parseAchievementsWorkbook(workbook);

        if (!payload.programsData.length) {
          throw new Error("No programs data found in Excel file.");
        }

        this.programsData = payload.programsData;
        this.olympiadsData = payload.olympiadsData;
        this.profilesData = payload.profilesData;
        this.programsList = payload.programsList;
        this.combinedData = payload.combinedData;

        if (this.showParseLogs) {
          console.log("Achievements data loaded:", {
            sheets: workbook.SheetNames,
            programs: this.programsData.length,
            olympiads: this.olympiadsData.length,
            programsList: this.programsList.length,
          });
        }
      } catch (error) {
        console.error("Error loading achievements data:", error);
        this.programsData = [];
        this.olympiadsData = [];
        this.profilesData = [];
        this.programsList = [];
        this.combinedData = [];
        this.isLoadError = true;
      } finally {
        this.isLoadingData = false;
        this.$nextTick(() => this.updateParentHeight());
      }
    },
    getMatchingPrograms(
      olympiad: OlympiadData,
      profile: string,
      level: number
    ): ProgramWithBenefits[] {
      return this.programsList.filter((program) => {
        if (program.megaTag === "All") return true;

        const conditions = program.megaTag.split(";").map((condition) => {
          const [key, value] = condition.split(":");
          return { key, value };
        });

        return conditions.every(({ key, value }) => {
          switch (key) {
            case "Profile":
              return value.split(",").includes(profile);
            case "Level":
              const levels = value.split(",").map(Number);
              return levels.includes(level);
            case "Grade":
              return (
                this.selectedGrade &&
                value.split(",").includes(this.selectedGrade)
              );
            case "Olympiad": // Add new case for Olympiad name matching
              const olympiadNames = value.split(",");
              return olympiadNames.includes(olympiad.name);
            default:
              return true;
          }
        });
      });
    },
    handleSearch(event: CustomEvent) {
      this.searchQuery = event.detail.value || "";
      this.showSuggestions = true;
      console.log("Search query updated:", this.searchQuery);
      console.log(
        "Normalized search query:",
        this.normalizeText(this.searchQuery)
      );

      // Reset Grade and Profile when search query changes
      if (!this.isOlympiadSelected) {
        this.selectedGrade = "";
        this.selectedProfile = "";
      }
    },
    onAchievementsSearchInput() {
      this.showSuggestions = true;
      if (!this.isOlympiadSelected) {
        this.selectedGrade = "";
        this.selectedProfile = "";
      }
    },
    selectSuggestion(suggestion: string) {
      this.searchQuery = suggestion; // This will be an exact match
      this.showSuggestions = false;
      console.log("Selected suggestion:", suggestion);
    },
    changeRandomFact() {
      const newFact =
        this.funFacts[Math.floor(Math.random() * this.funFacts.length)];
      // Ensure we don't show the same fact twice in a row
      if (newFact === this.currentFact && this.funFacts.length > 1) {
        this.changeRandomFact();
        return;
      }
      this.currentFact = newFact;
    },
    prefillSearchQuery(value = "") {
      this.searchQuery = value;
    },
    openProgramModal() {
      this.showProgramModal = true;
    },
    closeProgramModal() {
      this.showProgramModal = false;
      this.programSearchQuery = "";
      this.modalSelectedCampus = "all";
    },
    selectProgram(programName: string) {
      console.log("Attempting to select program:", {
        programName,
        modalSelectedCampus: this.modalSelectedCampus,
      });

      // Debug all programs for the selected campus
      console.log(
        "Available programs in selected campus:",
        this.programsList.filter(
          (p) =>
            p.campus === this.modalSelectedCampus ||
            (this.modalSelectedCampus === "all" && p.campus === "Москва") ||
            p.campus === "all"
        )
      );

      // First try exact match with campus
      let selectedProgram = this.programsList.find((p) => {
        const matchesName =
          this.normalizeText(p.title) === this.normalizeText(programName);
        const matchesCampus =
          p.campus === this.modalSelectedCampus ||
          (this.modalSelectedCampus === "all" && p.campus === "Москва") ||
          p.campus === "all";

        console.log("Checking program match:", {
          title: p.title,
          normalizedTitle: this.normalizeText(p.title),
          normalizedProgramName: this.normalizeText(programName),
          campus: p.campus,
          matchesName,
          matchesCampus,
          modalCampus: this.modalSelectedCampus,
        });

        return matchesName && matchesCampus;
      });

      // If no match found, try without campus restriction
      if (!selectedProgram) {
        console.log("No exact match found, trying fallback...");
        selectedProgram = this.programsList.find(
          (p) => this.normalizeText(p.title) === this.normalizeText(programName)
        );
      }

      if (selectedProgram) {
        console.log("Program found:", selectedProgram);
        // Store old program name for comparison
        const oldProgramName = this.selectedProgramName;

        // Update selected program
        this.selectedProgramName = selectedProgram.title;
        this.selectedCampus = selectedProgram.campus || "Москва";
        console.log("Program selected:", {
          name: this.selectedProgramName,
          campus: this.selectedCampus,
        });

        // Only process cart cleanup if we're actually changing programs
        if (oldProgramName !== this.selectedProgramName) {
          // Wait for calculatorResults to update with new program data
          this.$nextTick(() => {
            if (this.calculatorResults) {
              // Create a set of valid achievement titles for the new program
              const validAchievements = new Set<string>();
              Object.values(this.calculatorResults).forEach((category) => {
                category.forEach((achievement) => {
                  validAchievements.add(achievement.title);
                });
              });

              // Filter out cart items that are no longer valid
              const invalidItems = this.cartItems.filter(
                (item) => !validAchievements.has(item.title)
              );

              // Remove invalid items from cart
              if (invalidItems.length > 0) {
                this.cartItems = this.cartItems.filter((item) =>
                  validAchievements.has(item.title)
                );

                // Notify user about removed items
                console.log("Removed invalid achievements:", invalidItems);

                // You might want to show a notification to the user here
                // For example, using an alert or toast
                const removedCount = invalidItems.length;
                const message = `${removedCount} достижени${
                  removedCount > 1 ? "я" : "е"
                } ${
                  removedCount > 1 ? "были удалены" : "было удалено"
                } из калькулятора, так как ${
                  removedCount > 1 ? "они не учитываются" : "оно не учитывается"
                } на выбранной программе.`;

                // You'll need to implement showToast method or use your preferred notification system
                this.currentEncouragement = message;
                this.showEncouragement = true;
                setTimeout(() => {
                  this.showEncouragement = false;
                }, 4000);
              }
            }
          });
        }
      } else {
        console.warn("No matching program found for:", programName);
        return; // Exit early if no program found
      }

      this.closeProgramModal();

      // Force recalculation of calculator results
      this.$nextTick(() => {
        if (this.calculatorResults) {
          console.log("Calculator results updated:", this.calculatorResults);
        } else {
          console.warn("No calculator results after selection");
        }
      });
    },
    addToCart(item: any) {
      console.log("Adding item to cart:", item);

      if (!this.isItemInCart(item)) {
        // Extract points from either direct points property or from text
        let itemPoints = 0;
        if (typeof item.points === "number") {
          itemPoints = item.points;
        } else if (typeof item.points === "string") {
          // Try to extract number from string like "Победитель - 8"
          const pointsMatch = item.points.match(/\d+/);
          itemPoints = pointsMatch ? parseInt(pointsMatch[0]) : 0;
        }

        // Keep original category
        let category = item.category || "Индивидуальные достижения";

        // If it's an olympiad but missing category, set it as Olympiad
        if (
          (item.type === "Олимпиады" || item.type === "Olympiad") &&
          !item.category
        ) {
          category = "Олимпиады";
        }

        console.log(
          "Adding to cart with points:",
          itemPoints,
          "and category:",
          category
        );

        const cartItem = {
          title: item.title,
          points: itemPoints,
          details: item.details,
          category: category,
        };

        this.cartItems.push(cartItem);
        
        // Show game-like achievement popup
        this.showAchievementUnlocked(cartItem);
        
        this.showRandomEncouragement();
      }
    },
    showRandomEncouragement() {
      let message = "";
      if (this.cartItems.length === 0) {
        message =
          "Добавляйте свои достижения, и я помогу подсчитать ваши дополнительные баллы! 🎯";
      } else if (this.cartTotal >= 10) {
        message =
          "Поздравляю! Вы набрали максимальное количество баллов за индивидуальные достижения! 🎉";
      } else {
        const randomMessage = this.encouragementMessages[
          Math.floor(Math.random() * this.encouragementMessages.length)
        ];
        message = randomMessage;
      }
      this.currentEncouragement = message;
      this.showEncouragement = true;
      setTimeout(() => {
        this.dismissEcouragement();
      }, 2222);
    },
    dismissEcouragement(){
      this.showEncouragement = false;
    },
    showAchievementUnlocked(item: { title: string; points: number; category?: string }) {
      this.achievementPopupData = item;
      this.showAchievementPopup = true;
      
      // Auto-dismiss after 2 seconds
      setTimeout(() => {
        this.hideAchievementPopup();
      }, 2000);
    },
    hideAchievementPopup() {
      this.showAchievementPopup = false;
      setTimeout(() => {
        this.achievementPopupData = null;
      }, 300); // Wait for fade-out animation
    },
    removeFromCart(index: number) {
      this.cartItems.splice(index, 1);
    },
    selectFilterCategory(category: string) {
      this.filterCategory = category;
    },
    openCartModal() {
      this.showCartModal = true;
    },
    closeCartModal() {
      this.showCartModal = false;
    },
    displayCategory(category: string): string {
      const categoryMap: { [key: string]: string } = {
        attestst: "Аттестат",
        attestat: "Аттестат",
        sport: "Спортивные достижения",
        olympiad: "Олимпиады и конкурсы",
        Attestst: "Аттестат",
        Attestat: "Аттестат",
        Sport: "Спортивные достижения",
        Olympiad: "Олимпиады и конкурсы",
      };
      return categoryMap[category] || category;
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 1024; // Matches lg breakpoint
    },
    isItemInCart(item: any): boolean {
      // For olympiads, check both title and profile
      if (item.type === "Олимпиады" || item.type === "Olympiad") {
        return this.cartItems.some(cartItem => {
          // Use olympiadProfile directly if available
          if (item.olympiadProfile) {
            // Extract profile from cartItem
            const cartItemProfile = cartItem.details && cartItem.details.includes("Профиль:") 
              ? cartItem.details.split("Профиль:")[1].split("\n")[0].trim() 
              : "";
            
            // Match on both title and profile
            return cartItem.title === item.title && cartItemProfile === item.olympiadProfile;
          } else {
            // Fall back to extracting from details if olympiadProfile is not available
            const itemProfile = item.details && item.details.includes("Профиль:") 
              ? item.details.split("Профиль:")[1].split("\n")[0].trim() 
              : "";
            
            // Extract profile from cartItem
            const cartItemProfile = cartItem.details && cartItem.details.includes("Профиль:") 
              ? cartItem.details.split("Профиль:")[1].split("\n")[0].trim() 
              : "";
            
            // Match on both title and profile
            return cartItem.title === item.title && cartItemProfile === itemProfile;
          }
        });
      }
      
      // For non-olympiad items, continue using the title-only check
      return this.cartItems.some(cartItem => cartItem.title === item.title);
    },
    // Method to handle modal dismissal
    async handleFeatureModalDismiss() {
      this.showFeatureModal = false;
      await Preferences.set({ key: 'hasSeenFeatureShowcase', value: 'true' });
    },

    // Add this method to check if the showcase should be shown
    async checkShowFeatureShowcase() {
      console.log("Checking if feature showcase should be shown...");
      try {
        const { value } = await Preferences.get({ key: 'hasSeenFeatureShowcase' });
        console.log("Value from Preferences for 'hasSeenFeatureShowcase':", value);
        if (!value) {
          console.log("Setting showFeatureModal to true");
          this.showFeatureModal = true;
        } else {
          console.log("Feature showcase already seen.");
        }
      } catch (error) {
        console.error("Error checking Preferences:", error);
        // Optionally, decide whether to show the modal on error
        // this.showFeatureModal = true; 
      }
    },
    
    // Force show feature showcase for testing
    forceShowFeatureShowcase() {
      console.log("Forcing feature showcase to show");
      this.showFeatureModal = true;
    }
  },
  watch: {
    searchQuery() {
      this.changeRandomFact();
    },
  },
  async mounted() {
    console.log(
      "Разработчик: Вирабян Арам (avirabyan@hse.ru). Специально для Высшей школы экономики для Приемной комиссии. 2024"
    );

    // Check if the feature showcase should be shown
    await this.checkShowFeatureShowcase();
    document.body.classList.remove("dark");

    // Check for saved school name
    const savedSchoolName = localStorage.getItem("testingSchoolName");
    if (savedSchoolName) {
      this.hasEnteredSchoolName = true;
    }

    if(this.isPageLockedAndRequiresPassword){
      if(localStorage.getItem("accessPassword") && localStorage.getItem("accessPassword") == this.accessPassword){
        this.isPageLockedAndRequiresPassword = false;
      }
    }

    if(this.$route && this.$route.query && this.$route.query["Domain"]){
      this.dataDomain = this.$route.query["Domain"] + "" || "BA";
    }else{
      this.dataDomain = this.domain;
    }
    
    this.dataDomain = this.dataDomain.toUpperCase().replace(/[^BMA]/g, "");
    console.log(
      "This widget will data for this domain: " + this.dataDomain
    );

    await Preferences.set({
      key: "theme",
      value: "light",
    });
    document.body.classList.remove("dark");

    console.log("Component mounted");
    this.loadExcelData();

    // Add click outside listener to dismiss suggestions
    document.addEventListener("click", (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (
        !target.closest(".search-modern") &&
        !target.closest(".suggestion-item")
      ) {
        this.showSuggestions = false;
      }
    });

    this.changeRandomFact(); // Initialize with a random fact

    // Add mobile detection
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);

    this.$nextTick(() => {
      this.updateParentHeight();
    });

    // Observe changes in the content and update height accordingly
    const resizeObserver = new ResizeObserver(() => {
      this.updateParentHeight();
    });
    
    // Make sure this.$el exists before observing
    if (this.$el) {
      resizeObserver.observe(this.$el);
      this.resizeObserver = resizeObserver;
    }
  },
  beforeUnmount() {
    // Clean up event listener
    document.removeEventListener("click", () => {});
    window.removeEventListener("resize", this.checkMobile);
    // Disconnect the observer when the component is unmounted
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  setup() {
    return {
      close,
      trash,
      folderOpenOutline,
    };
  },
});
</script>

<style scoped>
.widget-data-loading,
.widget-data-error {
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 20px;
}

.widget-data-loading__inner {
  width: 100%;
  max-width: 520px;
  text-align: center;
}

.widget-data-loading__spinner {
  width: 44px;
  height: 44px;
  margin: 0 auto 16px;
  border-radius: 50%;
  border: 3px solid #dbeafe;
  border-top-color: #2563eb;
  animation: widget-data-spin 0.85s linear infinite;
}

.widget-data-loading__title,
.widget-data-error__title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #0f172a;
}

.widget-data-loading__subtitle,
.widget-data-error__subtitle {
  margin: 8px 0 0;
  font-size: 0.875rem;
  color: #64748b;
}

.widget-data-loading__skeleton {
  margin-top: 28px;
  display: grid;
  gap: 12px;
}

.widget-data-loading__line {
  height: 14px;
  border-radius: 999px;
  background: linear-gradient(90deg, #e2e8f0 0%, #f1f5f9 40%, #e2e8f0 80%);
  background-size: 200% 100%;
  animation: widget-data-shimmer 1.4s ease-in-out infinite;
}

.widget-data-loading__line--long { width: 84%; margin: 0 auto; }
.widget-data-loading__line--short { width: 62%; margin: 0 auto; }

.widget-data-loading__block {
  height: 88px;
  border-radius: 16px;
  background: linear-gradient(90deg, #e2e8f0 0%, #f1f5f9 40%, #e2e8f0 80%);
  background-size: 200% 100%;
  animation: widget-data-shimmer 1.4s ease-in-out infinite;
}

@keyframes widget-data-spin {
  to { transform: rotate(360deg); }
}

@keyframes widget-data-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (prefers-reduced-motion: reduce) {
  .widget-data-loading__spinner,
  .widget-data-loading__line,
  .widget-data-loading__block {
    animation: none;
  }
}

/* ========================================
   HEADING STYLES (p tags styled as headings to avoid parent site overrides)
   ======================================== */
.heading-1,
.heading-2,
.heading-3,
.heading-4,
.heading-5 {
  margin: 0;
  font-family: inherit;
  line-height: 1.3;
}
.heading-1 { font-size: 32px !important; font-weight: 700 !important; }
.heading-2 { font-size: 24px !important; font-weight: 600 !important; }
.heading-3 { font-size: 18px !important; font-weight: 600 !important; }
.heading-4 { font-size: 14px !important; font-weight: 500 !important; }
.heading-5 { font-size: 12px !important; font-weight: 500 !important; }

/* ========================================
   CUSTOM WIDGET UTILITIES (replacing Tailwind)
   ======================================== */
.widget-min-h-screen { min-height: 100vh; }
.widget-flex { display: flex; }
.widget-flex-col { flex-direction: column; }
.widget-items-center { align-items: center; }
.widget-items-start { align-items: flex-start; }
.widget-justify-center { justify-content: center; }
.widget-justify-between { justify-content: space-between; }
.widget-justify-start { justify-content: flex-start; }
.widget-w-full { width: 100%; }
.widget-max-w-md { max-width: 448px; }
.widget-flex-1 { flex: 1 1 0%; }
.widget-gap-2 { gap: 8px; }
.widget-gap-3 { gap: 12px; }
.widget-gap-4 { gap: 16px; }
.widget-space-y-2 > * + * { margin-top: 8px; }
.widget-space-y-3 > * + * { margin-top: 12px; }
.widget-space-y-4 > * + * { margin-top: 16px; }
.widget-space-y-6 > * + * { margin-top: 24px; }
.widget-bg-white { background-color: #ffffff; }
.widget-bg-white-80 { background-color: rgba(255, 255, 255, 0.8); }
.widget-bg-white-10 { background-color: rgba(255, 255, 255, 0.1); }
.widget-bg-gray-100 { background-color: #f3f4f6; }
.widget-bg-gray-100-80 { background-color: rgba(243, 244, 246, 0.8); }
.widget-bg-blue-50 { background-color: #eff6ff; }
.widget-bg-blue-500 { background-color: #3b82f6; }
.widget-backdrop-blur-xl { backdrop-filter: blur(24px); }
.widget-rounded-2xl { border-radius: 16px; }
.widget-rounded-xl { border-radius: 12px; }
.widget-rounded-lg { border-radius: 8px; }
.widget-rounded-full { border-radius: 9999px; }
.widget-p-2 { padding: 8px; }
.widget-p-3 { padding: 12px; }
.widget-p-4 { padding: 16px; }
.widget-p-6 { padding: 24px; }
.widget-p-8 { padding: 32px; }
.widget-pb-0 { padding-bottom: 0; }
.widget-pb-2 { padding-bottom: 8px; }
.widget-pt-4 { padding-top: 16px; }
.widget-px-1 { padding-left: 4px; padding-right: 4px; }
.widget-px-6 { padding-left: 24px; padding-right: 24px; }
.widget-py-2 { padding-top: 8px; padding-bottom: 8px; }
.widget-py-3 { padding-top: 12px; padding-bottom: 12px; }
.widget-py-4 { padding-top: 16px; padding-bottom: 16px; }
.widget-shadow-lg { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); }
.widget-shadow-sm { box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); }
.widget-relative { position: relative; }
.widget-absolute { position: absolute; }
.widget-mb-1 { margin-bottom: 4px; }
.widget-mb-4 { margin-bottom: 16px; }
.widget-mt-1 { margin-top: 4px; }
.widget-mt-2 { margin-top: 8px; }
.widget-mt-8 { margin-top: 32px; }
.widget-ml-1 { margin-left: 4px; }
.widget--ml-2 { margin-left: -8px; }
.widget--mt-19 { margin-top: -76px; }
.widget--mb-4 { margin-bottom: -16px; }
.widget-left-neg { left: -6px; }
.widget-bottom-3 { bottom: 12px; }
.widget-z-10 { z-index: 10; }
.widget-z-50 { z-index: 50; }
.widget-overflow-hidden { overflow: hidden; }
.widget-overflow-y-auto { overflow-y: auto; }
.widget-object-contain { object-fit: contain; }
.widget-text-xs { font-size: 12px; }
.widget-text-sm { font-size: 14px; }
.widget-text-lg { font-size: 18px; }
.widget-text-2xl { font-size: 24px; }
.widget-font-medium { font-weight: 500; }
.widget-font-semibold { font-weight: 600; }
.widget-font-bold { font-weight: 700; }
.widget-font-normal { font-weight: 400; }
.widget-text-center { text-align: center; }
.widget-text-gray-500 { color: #6b7280; }
.widget-text-gray-600 { color: #4b5563; }
.widget-text-gray-900 { color: #111827; }
.widget-text-gray-400 { color: #9ca3af; }
.widget-text-blue-600 { color: #2563eb; }
.widget-text-blue-700 { color: #1d4ed8; }
.widget-text-purple-600 { color: #9333ea; }
.widget-text-white { color: #ffffff; }
.widget-leading-tight { line-height: 1.25; }
.widget-inline-flex { display: inline-flex; }
.widget-border-t { border-top-width: 1px; }
.widget-border-gray-200 { border-color: #e5e7eb; }
.widget-w-4 { width: 16px; height: 16px; }
.widget-w-5 { width: 20px; height: 20px; }
.widget-w-8 { width: 32px; height: 32px; }
.widget-w-12 { width: 48px; height: 48px; }
.widget-w-20 { width: 86px; height: 86px; }
.widget-max-w-280 { max-width: 280px; }
.widget-h-screen-calc { height: calc(100vh - 200px); }
@media (min-width: 1024px) {
  .widget-lg-sticky { position: sticky; }
  .widget-lg-top-4 { top: 16px; }
  .widget-lg-top-calc { top: calc(64px + 180px); }
  .widget-lg-mt-0 { margin-top: 0; }
  .widget-lg-hidden { display: none; }
}
.widget-fixed { position: fixed; }
.widget-bottom-6 { bottom: 24px; }
.widget-right-6 { right: 24px; }
.widget-left-4 { left: 16px; }
.widget-right-4 { right: 16px; }
.widget-w-14 { width: 56px; height: 56px; }
.widget-w-6 { width: 24px; height: 24px; }
.widget-bg-blue-600 { background-color: #2563eb; }
.widget-bg-blue-600:hover { background-color: #1d4ed8; }
.widget-bg-red-500 { background-color: #ef4444; }
.widget-badge-pos { position: absolute; top: -8px; right: -8px; min-width: 20px; height: 20px; }
.widget-toast-container { background-color: #ffffff; border-radius: 16px; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); padding: 16px; margin-left: auto; margin-right: auto; max-width: 448px; }
.widget-text-gray-800 { color: #1f2937; }
.widget-text-xl { font-size: 20px; }
.widget-mb-2 { margin-bottom: 8px; }
.widget-mt-4 { margin-top: 16px; }
.widget-mt-3 { margin-top: 12px; }
.widget-mt-6 { margin-top: 24px; }
.widget-py-6 { padding-top: 24px; padding-bottom: 24px; }
.widget-w-16 { width: 64px; height: 64px; }
.widget-bg-green-100 { background-color: #dcfce7; }
.widget-text-green-600 { color: #16a34a; }
.widget-bg-gray-100:hover { background-color: #e5e7eb; }
.widget-bg-gray-100:active { background-color: #d1d5db; }
.widget-mx-auto { margin-left: auto; margin-right: auto; }
.widget-inline-block { display: inline-block; }
.widget-py-2 { padding-top: 8px; padding-bottom: 8px; }
.widget-btn-secondary { background-color: #f3f4f6; color: #4b5563; border-radius: 12px; font-weight: 500; transition: background-color 0.2s; }
.widget-btn-secondary:hover { background-color: #e5e7eb; }
.widget-btn-secondary:active { background-color: #d1d5db; }
.widget-input-text { font-size: 18px; letter-spacing: 0.05em; text-align: center; appearance: none; line-height: 1.5; }
.widget-input-border { border-width: 1px; border-style: solid; border-color: #e5e7eb; transition: all 0.2s; outline: none; }
.widget-input-border:focus { border-color: #3b82f6; box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2); }
.widget-btn-primary { width: 100%; color: #ffffff; border-radius: 12px; font-weight: 500; transition: background-color 0.2s; }
.widget-btn-primary:hover { background-color: #2563eb; }
.widget-btn-primary:active { background-color: #1d4ed8; }
.widget-link-blue { color: #2563eb; }
.widget-link-blue:hover { text-decoration: underline; }
.widget-link-purple { color: #9333ea; font-weight: 500; }
.widget-link-purple:hover { color: #7e22ce; text-decoration: underline; }
.widget-link-purple:focus { outline: none; }
.widget-hover-red:hover { color: #ef4444; }
.widget-hover-red { transition: color 0.2s; }
.widget-bubble-tail { width: 0; height: 0; border-top: 6px solid transparent; border-right: 12px solid #eff6ff; border-bottom: 6px solid transparent; }

/* Apple/Ionic-like side cards */
.sidebar-glass-card {
  background: linear-gradient(180deg, rgba(246, 247, 250, 0.84) 0%, rgba(240, 242, 247, 0.8) 100%);
  border: 1px solid rgba(15, 23, 42, 0.05);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.75),
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 6px 16px rgba(15, 23, 42, 0.04);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

/* ========================================
   RESPONSIVE GRID LAYOUT
   ======================================== */
.main-grid-container,
.main-content-column {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

@media (max-width: 767px) {
  .main-grid-container {
    padding-left: 12px;
    padding-right: 12px;
  }
}

@media (min-width: 768px) {
  .main-grid-container {
    padding-left: 5vw !important;
    padding-right: 5vw !important;
  }
}

@media (min-width: 1024px) {
  .main-grid-container {
    grid-template-columns: 2fr 1fr !important;
  }
  .main-content-column {
    grid-column: span 1 !important;
  }
}

/* ========================================
   iOS-style search bar 
   ======================================== */
.search-ios {
  --background: rgba(255, 255, 255, 0.95) !important;
  --color: #000000;
  --placeholder-color: #808080;
  --icon-color: #808080;
  --clear-button-color: #808080;
  --border-radius: 10px;
  --box-shadow: none;
  --placeholder-opacity: 0.6;
  --padding-top: 16px;
  --padding-bottom: 16px;
  --padding-start: 16px;
  --padding-end: 16px;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  margin: 0;
  position: relative;
}

/* Make close circle icon bigger */
::v-deep(.searchbar-clear-button.sc-ion-searchbar-ios) {
  transform: scale(1.5);
  margin-right: 8px;
}

/* Target the search icon specifically */
.search-ios::part(search-icon) {
  position: absolute;
  left: 16px; /* Position icon from the left edge */
  top: 50%;
  transform: translateY(-50%);
  margin-left: 5px; /* Add small extra margin if needed */
}

/* Adjust input padding to not overlap the icon */
.search-ios::part(native) {
  padding-left: 48px !important; /* Increase input padding to make space for icon */
}

.search-ios.searchbar-focused {
  --background: rgba(255, 255, 255, 1) !important;
  /* Even brighter when focused */
}

/* Dark mode search bar */
:root.dark .search-ios {
  --background: rgba(28, 28, 30, 0.8) !important;
  /* Brighter in dark mode */
  --color: rgb(255, 255, 255);
  --placeholder-color: rgb(174, 174, 178);
  --icon-color: rgb(174, 174, 178);
  --clear-button-color: rgb(174, 174, 178);
}

:root.dark .search-ios.searchbar-focused {
  --background: rgba(28, 28, 30, 0.95) !important;
  /* Even brighter when focused in dark mode */
}

/* iOS-style select */
.select-ios {
  -webkit-appearance: none;
  appearance: none;
  background-color: rgba(255, 255, 255, 0.5);
  color: rgb(0, 0, 0);
  border-radius: 10px;
  border: none;
  padding: 12px 44px 12px 16px;
  font-size: 17px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24' stroke='rgb(128, 128, 128)' stroke-width='2'%3e%3cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;
}

.select-ios:focus {
  background-color: rgba(255, 255, 255, 0.8);
  outline: none;
}

/* Dark mode select */
:root.dark .select-ios {
  background-color: rgba(28, 28, 30, 0.5);
  color: rgb(255, 255, 255);
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3e%3cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/%3e%3c/svg%3e");
}

:root.dark .select-ios:focus {
  background-color: rgba(28, 28, 30, 0.8);
}

/* Smooth transitions */
.search-ios,
.select-ios {
  transition: background-color 0.2s ease-in-out;
}

/* Remove default focus rings for iOS */
* {
  -webkit-tap-highlight-color: transparent;
}

/* Animation refinements */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.group {
  animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Add these new styles */
.empty-state-enter-active,
.empty-state-leave-active {
  transition: all 0.3s ease;
}

.empty-state-enter-from,
.empty-state-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.fact-card-enter-active,
.fact-card-leave-active {
  transition: all 0.3s ease;
}

.fact-card-enter-from,
.fact-card-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

@keyframes pulse-ring {
  0% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.1);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(59, 130, 246, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
  }
}

.animate-pulse-ring {
  animation: pulse-ring 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Dark mode pulse ring */
:root.dark .animate-pulse-ring {
  animation-name: pulse-ring-dark;
}

@keyframes pulse-ring-dark {
  0% {
    box-shadow: 0 0 0 0 rgba(96, 165, 250, 0.1);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(96, 165, 250, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(96, 165, 250, 0);
  }
}

.program-modal {
  --height: 80%;
  --border-radius: 16px 16px 0 0;
}

@media (min-width: 768px) {
  .program-modal {
    --height: 600px;
    --border-radius: 16px;
  }
}

.message-bubble-enter-active,
.message-bubble-leave-active {
  transition: all 0.3s ease;
}

.message-bubble-enter-from,
.message-bubble-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.cart-modal {
  --height: 100%;
  --width: 100%;
}

@media (min-width: 768px) {
  .cart-modal {
    --width: 400px;
    --height: 600px;
  }
}

/* Ensure proper styling for ion-modal content */
::v-deep(.modal-content) {
  background: rgb(249, 250, 251);
}

::v-deep(.modal-wrapper) {
  background: transparent;
}

/* Hide the desktop cart on mobile */
@media (max-width: 1023px) {
  .lg\:sticky {
    display: none;
  }
}

/* Add these new styles for the mobile toast */
.animate-slide-up {
  animation: slideUp 0.3s ease-out forwards;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Hide desktop encouragement message on mobile */
@media (max-width: 1023px) {
  .lg\:sticky .relative:has(> img[alt="Воронка думает"]) {
    display: none;
  }
}

/* Add these new styles for the rainbow toast */
.toast-container {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(10px);
}

.rainbow-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 148, 148, 0.1),
    rgba(255, 187, 147, 0.1),
    rgba(255, 222, 147, 0.1),
    rgba(147, 255, 153, 0.1),
    rgba(147, 198, 255, 0.1),
    rgba(184, 147, 255, 0.1),
    rgba(255, 147, 237, 0.1)
  );
  opacity: 0.7;
  pointer-events: none;
}

.toast-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  animation: shine 3s infinite;
}

@keyframes shine {
  100% {
    left: 200%;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-slide-up {
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

/* Remove previous rainbow-blur-bg styles */

/* Native achievements search input (replaces ion-searchbar for height control) */
.achievements-search-native input::placeholder {
  color: #808080;
  opacity: 0.6;
}

/* Focus border/ring for search input (match dropdowns) */
.achievements-search-native:focus-within {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05) !important;
  outline: none;
}

/* Focus border/ring for grade and profile dropdowns */
.search-block-select:focus {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2) !important;
  outline: none;
}

/* Add these new styles to fix searchbar height (other searchbars: program modal, calculator) */
::v-deep(.searchbar-input-container.sc-ion-searchbar-ios) {
  height: 56px !important; /* Taller search field */
  min-height: 56px !important;
}

::v-deep(.searchbar-input.sc-ion-searchbar-ios) {
  height: 100% !important;
  font-size: 17px !important;
  line-height: normal !important;
}

/* Also ensure the main searchbar maintains height */
::v-deep(.ion-searchbar) {
  --min-height: 56px;
  height: 56px !important;
}

/* Fix pulse animation alignment */
.animate-pulse-ring {
  animation: pulse-ring 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  margin: 0;
  border-radius: inherit;
}

/* Update searchbar container to be relative for proper animation positioning */
.relative.bg-gray-100\/80 {
  position: relative;
  overflow: hidden;
}

/* Ensure searchbar and animation have same border radius */
::v-deep(.searchbar-input-container.sc-ion-searchbar-ios),
.animate-pulse-ring {
  border-radius: 10px;
}

/* Segment Description Styling */
.segment-description-container {
  background-color: rgba(243, 244, 246, 0.7); /* Tailwind gray-100 with opacity */
  backdrop-filter: blur(5px);
  border-radius: 12px;
  padding: 12px 16px;
  border: 1px solid rgba(229, 231, 235, 0.6); /* Tailwind gray-200 with opacity */
}

.segment-description-text {
  font-size: 14px; /* Set specific pixel size */
  color: #4b5563; /* Tailwind gray-600 */
  line-height: 1.5;
  text-align: left;
  margin: 0;
}

/* Fade transition for the description */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Review Modal Styles */
.review-modal {
  --width: 90%;
  --max-width: 500px;
  --height: auto;
  --max-height: 80vh;
  --border-radius: 16px;
  --box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  align-items: center;
  justify-content: center;
}

.review-modal-content {
  background: white;
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  position: relative;
}

.review-modal-image {
  width: 100px;
  height: 100px;
  margin: 0 auto 16px auto;
  display: block;
}

.review-modal-title {
  font-size: 20px; /* 20px */
  font-weight: 600;
  color: #1f2937; /* gray-800 */
  margin-bottom: 12px;
}

.review-modal-text {
  font-size: 15px; /* Set specific pixel size */
  color: #4b5563; /* gray-600 */
  line-height: 1.6;
  margin-bottom: 0;
}

.close-button {
  position: absolute;
  top: 8px;
  right: 8px;
  --color: #9ca3af; /* gray-400 */
  --color-activated: #6b7280; /* gray-500 */
  --padding-start: 6px;
  --padding-end: 6px;
  --padding-top: 6px;
  --padding-bottom: 6px;
}

/* Make review button more visible */
button[class*="text-purple-600"] {
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 6px 12px !important;
  background-color: #f3f4f6 !important;
  border-radius: 8px !important;
  border: 1px solid #e5e7eb !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.2s !important;
}

button[class*="text-purple-600"]:hover {
  background-color: #ede9fe !important;
  border-color: #ddd6fe !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}

/* Base text styles with !important */
:deep(*) {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  line-height: 1.5 !important;
  font-size: 16px !important; /* Set base font size for all text */
}

/* Headings */
:deep(h1) {
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
}

:deep(h2) {
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
}

:deep(h3) {
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
}

:deep(h4) {
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
}

/* Regular text */
:deep(p) {
  font-size: 16px !important;
  line-height: 1.5 !important;
}

/* Small text */
:deep(.text-sm) {
  font-size: 16px !important;
  line-height: 1.5 !important;
}

/* Extra small text */
:deep(.text-xs) {
  font-size: 16px !important;
  line-height: 1.5 !important;
}

/* Search bar text */
:deep(.search-ios) {
  font-size: 16px !important;
  line-height: 1.5 !important;
}

/* Select text */
:deep(.select-ios) {
  font-size: 16px !important;
  line-height: 1.5 !important;
}

/* Button text */
:deep(button) {
  font-size: 16px !important;
  line-height: 1.5 !important;
}


/* Modal text */
:deep(.modal-content) {
  font-size: 16px !important;
  line-height: 1.5 !important;
}

/* Keep disclaimer text size as is */
:deep(.text-center.text-gray-400.text-xs) {
  font-size: 12px !important;
}

/* Keep disclaimer link text size consistent */
:deep(.text-center.text-gray-400.text-xs a) {
  font-size: 12px !important;
  line-height: 1.5 !important;
}

/* Keep review button text size as is */
button[class*="text-purple-600"] {
  font-size: 14px !important;
}

/* Keep segment description text size as is */
.segment-description-text {
  font-size: 14px !important;
}

/* Keep review modal text size as is */
.review-modal-text {
  font-size: 15px !important;
}

/* Keep review modal title size as is */
.review-modal-title {
  font-size: 20px !important;
}

@media (max-width: 640px) {
  .grid {
    gap: 8px !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .relative.bg-gray-100\/80 {
    padding: 8px !important;
  }

  .p-6 {
    padding: 12px !important;
  }

  .space-y-3 > * + * {
    margin-top: 8px !important;
  }

  .space-y-2 > * + * {
    margin-top: 6px !important;
  }

  .cart-modal {
    --padding-start: 8px !important;
    --padding-end: 8px !important;
  }

  .ion-padding {
    padding: 8px !important;
  }

  .py-3 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }

  .mt-2 {
    margin-top: 6px !important;
  }
}

/* ========================================
   ACHIEVEMENT POPUP ANIMATIONS
   ======================================== */

/* Popup enter/leave transitions */
.achievement-popup-enter-active {
  animation: popup-enter 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.achievement-popup-leave-active {
  animation: popup-leave 0.25s ease-in forwards;
}

@keyframes popup-enter {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes popup-leave {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

/* Card scale animation on enter */
.achievement-card-animated {
  animation: card-pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s both;
}

@keyframes card-pop {
  0% {
    opacity: 0;
    transform: scale(0.3) translateY(40px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Trophy bounce animation */
.trophy-bounce {
  animation: trophy-bounce 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s both;
}

@keyframes trophy-bounce {
  0% {
    opacity: 0;
    transform: scale(0) rotate(-20deg);
  }
  50% {
    transform: scale(1.2) rotate(10deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0);
  }
}

/* Rotating glow effect */
@keyframes rotate-glow {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Floating particles */
@keyframes float-particle {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-20px) scale(1.2);
    opacity: 1;
  }
}

/* Shimmer effect on points */
@keyframes shimmer {
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
}

/* Sparkle animation for celebration emojis */
@keyframes sparkle {
  0%, 100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  50% {
    transform: scale(1.3) rotate(15deg);
    opacity: 0.8;
  }
}
</style>


